/* THIS IS A GENERATED FILE - DO NOT MODIFY */

/* eslint-disable */

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  Time: { input: any; output: any; }
};

export type Access = {
  __typename?: 'Access';
  archived: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  metaData?: Maybe<Scalars['JSON']['output']>;
  status: AccessStatus;
  type: AccessType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user1: Scalars['String']['output'];
  user2: Scalars['String']['output'];
};

export type AccessCreateInput = {
  metaData?: InputMaybe<Scalars['JSON']['input']>;
  phoneOrEmail: Scalars['String']['input'];
  type: AccessType;
};

export enum AccessStatus {
  Active = 'active',
  Deny = 'deny',
  Pending = 'pending'
}

export enum AccessType {
  Direct = 'direct',
  Reverse = 'reverse'
}

export type Activity = {
  __typename?: 'Activity';
  activityPlanId: Scalars['Int']['output'];
  archived: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  duration: Scalars['Int']['output'];
  file?: Maybe<TeamFile>;
  fileId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  order: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ActivityFileInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  modelId?: InputMaybe<Scalars['String']['input']>;
  modelType?: InputMaybe<SocialModelType>;
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: TeamFileType;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityInput = {
  activityPlanId: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  duration: Scalars['Int']['input'];
  file?: InputMaybe<ActivityFileInput>;
  fileId?: InputMaybe<Scalars['Int']['input']>;
  order: Scalars['Int']['input'];
  title: Scalars['String']['input'];
};

export type ActivityPlan = {
  __typename?: 'ActivityPlan';
  activities?: Maybe<Array<Maybe<Activity>>>;
  archived: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  date?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isLocked: Scalars['Boolean']['output'];
  isTemplate: Scalars['Boolean']['output'];
  teamEventId?: Maybe<Scalars['Int']['output']>;
  template?: Maybe<ActivityPlan>;
  templateId?: Maybe<Scalars['Int']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

export type ActivityPlanInput = {
  activities?: InputMaybe<Array<InputMaybe<ActivityInput>>>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration: Scalars['Int']['input'];
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  isTemplate: Scalars['Boolean']['input'];
  teamEventId?: InputMaybe<Scalars['Int']['input']>;
  templateId?: InputMaybe<Scalars['Int']['input']>;
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityPlanUpdateInput = {
  activities?: InputMaybe<Array<InputMaybe<ActivityUpdateInput>>>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration: Scalars['Int']['input'];
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  isTemplate: Scalars['Boolean']['input'];
  teamEventId?: InputMaybe<Scalars['Int']['input']>;
  templateId?: InputMaybe<Scalars['Int']['input']>;
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityUpdateInput = {
  activityPlanId?: InputMaybe<Scalars['Int']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  file?: InputMaybe<ActivityFileInput>;
  fileId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AdminCoachMembershipSubscription = {
  __typename?: 'AdminCoachMembershipSubscription';
  entitlement: CoachMembershipEntitlement;
  subscription: CoachMembershipSubscription;
  user: User;
};

export type AdminGrantCoachMembershipInput = {
  billingPeriod: SubscriptionBillingPeriod;
  currentPeriodEnd: Scalars['DateTime']['input'];
  email: Scalars['String']['input'];
  environment?: InputMaybe<SubscriptionEnvironment>;
  note?: InputMaybe<Scalars['String']['input']>;
};

export type AdminMetricPeriod = {
  __typename?: 'AdminMetricPeriod';
  count: Scalars['Int']['output'];
  percentChange?: Maybe<Scalars['Float']['output']>;
  previousCount: Scalars['Int']['output'];
};

export type AdminMetrics = {
  __typename?: 'AdminMetrics';
  feedPostCount: Scalars['Int']['output'];
  liveStreamCount: Scalars['Int']['output'];
  teamCount: Scalars['Int']['output'];
  usageCards: Array<AdminUsageMetric>;
  userCount: Scalars['Int']['output'];
};

export type AdminModifyUserInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  coach?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isAdult?: InputMaybe<Scalars['Boolean']['input']>;
  isContentCreator?: InputMaybe<Scalars['Boolean']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  metaData?: InputMaybe<Scalars['JSON']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Position>;
  proTeamId?: InputMaybe<Scalars['Int']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdminRevokeCoachMembershipInput = {
  reason?: InputMaybe<Scalars['String']['input']>;
  subscriptionId: Scalars['Int']['input'];
};

export type AdminUsageMetric = {
  __typename?: 'AdminUsageMetric';
  color: Scalars['String']['output'];
  day: AdminMetricPeriod;
  faIcon: Scalars['String']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  month: AdminMetricPeriod;
  quarter: AdminMetricPeriod;
  total: Scalars['Int']['output'];
  week: AdminMetricPeriod;
};

export enum AnalyticsCoachPosition {
  Assistant = 'ASSISTANT',
  Coach = 'COACH',
  MainCoach = 'MAIN_COACH'
}

export enum AnalyticsEvent {
  JoinTeam = 'JOIN_TEAM',
  LeaveTeam = 'LEAVE_TEAM',
  NewTeam = 'NEW_TEAM',
  NewUser = 'NEW_USER',
  SetPosition = 'SET_POSITION'
}

export enum AnalyticsTeamRole {
  Coach = 'COACH',
  Player = 'PLAYER'
}

export type AnnouncementPushData = {
  __typename?: 'AnnouncementPushData';
  announcementId: Scalars['String']['output'];
  teamId: Scalars['String']['output'];
};

export type Answer = {
  __typename?: 'Answer';
  archived: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  pollId: Scalars['Int']['output'];
  text: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userAnswerCount: Scalars['Int']['output'];
  userAnswers: Array<UserAnswer>;
};

export type AppConfigUpdateInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  data: Scalars['JSON']['input'];
  key: Scalars['String']['input'];
};

export type AttachmentInput = {
  messageType?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export enum AttendanceStatus {
  Going = 'going',
  Maybe = 'maybe',
  NotGoing = 'notGoing'
}

export type AuthMethodsConfig = {
  __typename?: 'AuthMethodsConfig';
  login: Array<Maybe<Scalars['String']['output']>>;
  registration: Array<Maybe<Scalars['String']['output']>>;
};

export type AuthMethodsConfigInput = {
  login: Array<InputMaybe<Scalars['String']['input']>>;
  registration: Array<InputMaybe<Scalars['String']['input']>>;
};

export type CampaignLifecycleEventInput = {
  anonymousDeviceId?: InputMaybe<Scalars['String']['input']>;
  eventKey: Scalars['String']['input'];
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  occurredAt?: InputMaybe<Scalars['DateTime']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  sourceModelId?: InputMaybe<Scalars['String']['input']>;
  sourceModelType?: InputMaybe<Scalars['String']['input']>;
};

export type Category = {
  __typename?: 'Category';
  archived: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  forCoach: Scalars['Boolean']['output'];
  forFeed: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ChangePasswordInput = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
  newPasswordConfirmation: Scalars['String']['input'];
};

export type ChatAttachment = {
  __typename?: 'ChatAttachment';
  chatConversationId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  messageId?: Maybe<Scalars['Int']['output']>;
  messageType?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ChatConversation = {
  __typename?: 'ChatConversation';
  archived: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['Int']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  lastMessage?: Maybe<ChatMessage>;
  members: Array<PublicUser>;
  messages: Array<ChatMessage>;
  name?: Maybe<Scalars['String']['output']>;
  team?: Maybe<Team>;
  teamId?: Maybe<Scalars['String']['output']>;
  type: ChatConversationType;
  user?: Maybe<PublicUser>;
  userId?: Maybe<Scalars['String']['output']>;
  userIds?: Maybe<Array<Scalars['String']['output']>>;
};

export enum ChatConversationType {
  Coach = 'COACH',
  Parent = 'PARENT',
  Player = 'PLAYER',
  Private = 'PRIVATE',
  PrivateGroup = 'PRIVATE_GROUP',
  PublicGroup = 'PUBLIC_GROUP',
  Team = 'TEAM'
}

export type ChatInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['String']['input']>;
  type: ChatConversationType;
  userId?: InputMaybe<Scalars['String']['input']>;
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ChatMessage = {
  __typename?: 'ChatMessage';
  archived: Scalars['Boolean']['output'];
  attachments?: Maybe<Array<Maybe<ChatAttachment>>>;
  chatConversationId: Scalars['Int']['output'];
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['Int']['output'];
  like?: Maybe<Like>;
  likeCount: Scalars['Int']['output'];
  mediaUrl?: Maybe<Scalars['String']['output']>;
  user: PublicUser;
  userId: Scalars['String']['output'];
};

export type ChatMessageInput = {
  attachments?: InputMaybe<Array<AttachmentInput>>;
  chatConversationId: Scalars['Int']['input'];
  content?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  mediaUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ChatUpdateInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ChatConversationType>;
  userId?: InputMaybe<Scalars['String']['input']>;
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CoachMembershipEntitlement = {
  __typename?: 'CoachMembershipEntitlement';
  isActive: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  status: EntitlementStatus;
  subscription?: Maybe<CoachMembershipSubscription>;
  validFrom?: Maybe<Scalars['DateTime']['output']>;
  validUntil?: Maybe<Scalars['DateTime']['output']>;
};

export type CoachMembershipSubscription = {
  __typename?: 'CoachMembershipSubscription';
  autoRenewing: Scalars['Boolean']['output'];
  basePlanId?: Maybe<Scalars['String']['output']>;
  billingPeriod: SubscriptionBillingPeriod;
  cancelAt?: Maybe<Scalars['DateTime']['output']>;
  canceledAt?: Maybe<Scalars['DateTime']['output']>;
  currentPeriodEnd?: Maybe<Scalars['DateTime']['output']>;
  currentPeriodStart?: Maybe<Scalars['DateTime']['output']>;
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  entitlementKey: Scalars['String']['output'];
  environment: SubscriptionEnvironment;
  externalCustomerId?: Maybe<Scalars['String']['output']>;
  externalSubscriptionId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastVerifiedAt?: Maybe<Scalars['DateTime']['output']>;
  latestEventAt?: Maybe<Scalars['DateTime']['output']>;
  nextVerificationAt?: Maybe<Scalars['DateTime']['output']>;
  productId: Scalars['String']['output'];
  provider: SubscriptionProvider;
  status: SubscriptionStatus;
  userId: Scalars['String']['output'];
  verificationStatus: SubscriptionVerificationStatus;
};

export type Collection = {
  __typename?: 'Collection';
  archived: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  itemCount?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type CollectionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export enum CollectionItemType {
  Inventory = 'INVENTORY',
  Wishlist = 'WISHLIST'
}

export type CollectionUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Comment = {
  __typename?: 'Comment';
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  modelId: Scalars['String']['output'];
  modelType: SocialModelType;
  user: PublicUser;
  userId: Scalars['String']['output'];
};

export type CommentInput = {
  content: Scalars['String']['input'];
};

export type Config = {
  __typename?: 'Config';
  archived: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  data: Scalars['JSON']['output'];
  id: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ConfigNotification = {
  __typename?: 'ConfigNotification';
  ab: Scalars['Boolean']['output'];
  email: ConfigNotificationEmail;
  interval: Scalars['String']['output'];
  push: ConfigNotificationPush;
  send: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
};

export type ConfigNotificationAlt = {
  __typename?: 'ConfigNotificationAlt';
  name: Scalars['String']['output'];
  template?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ConfigNotificationData = {
  __typename?: 'ConfigNotificationData';
  AnnouncementCreated: ConfigNotification;
  AnnouncementUpdated: ConfigNotification;
  CoachPlayerJoined: ConfigNotification;
  Custom: ConfigNotification;
  EventAttendanceChanged: ConfigNotification;
  EventCreated: ConfigNotification;
  EventDeleted: ConfigNotification;
  EventRemind: ConfigNotification;
  EventRemind1dGAME: ConfigNotification;
  EventRemind1dPRACTICE: ConfigNotification;
  EventRemind1hGAME: ConfigNotification;
  EventRemind1hPRACTICE: ConfigNotification;
  EventRemind3dGAME: ConfigNotification;
  EventRemind3dPRACTICE: ConfigNotification;
  EventRemind3hGAME: ConfigNotification;
  EventRemind3hPRACTICE: ConfigNotification;
  EventRemind7dGAME: ConfigNotification;
  EventRemind7dPRACTICE: ConfigNotification;
  EventRemind12hGAME: ConfigNotification;
  EventRemind12hPRACTICE: ConfigNotification;
  EventRemindTEAM_MEAL: ConfigNotification;
  EventRemindTEAM_MEETING: ConfigNotification;
  EventRemindWATCH_FILM: ConfigNotification;
  EventUpdated: ConfigNotification;
  FeedPostRemind: ConfigNotification;
  Instructions: ConfigNotification;
  LineupPublished: ConfigNotification;
  MainCoachFirstTeamCreated: ConfigNotification;
  MainCoachNoPlayersCreated: ConfigNotification;
  MainCoachNoTeamCreated: ConfigNotification;
  MainCoachTeamCreated: ConfigNotification;
  MainCoachThreePlayersJoined: ConfigNotification;
  ParentControlLinked: ConfigNotification;
  ParentControlRemoved: ConfigNotification;
  ParentControlUnlinked: ConfigNotification;
  PollCreated: ConfigNotification;
  PollUpdated: ConfigNotification;
  PracticeEvaluationShared: ConfigNotification;
  TeamFeedGameResultPublished: ConfigNotification;
  TeamFeedMatchEventsPublished: ConfigNotification;
  TeamFeedPracticeResultsPublished: ConfigNotification;
  TeamFileCreated: ConfigNotification;
};

export type ConfigNotificationEmail = {
  __typename?: 'ConfigNotificationEmail';
  alt?: Maybe<Array<Maybe<ConfigNotificationAlt>>>;
  send: Scalars['Boolean']['output'];
  template?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ConfigNotificationPush = {
  __typename?: 'ConfigNotificationPush';
  alt?: Maybe<Array<Maybe<ConfigNotificationAlt>>>;
  send: Scalars['Boolean']['output'];
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ConfirmSubscriptionPurchaseInput = {
  basePlanId?: InputMaybe<Scalars['String']['input']>;
  billingPeriod: SubscriptionBillingPeriod;
  environment?: InputMaybe<SubscriptionEnvironment>;
  externalCustomerId?: InputMaybe<Scalars['String']['input']>;
  externalSubscriptionId: Scalars['String']['input'];
  payload?: InputMaybe<Scalars['JSON']['input']>;
  productId: Scalars['String']['input'];
  provider: SubscriptionProvider;
  purchasedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ConversationUnreadMessageCount = {
  __typename?: 'ConversationUnreadMessageCount';
  conversationId: Scalars['Int']['output'];
  teamId: Scalars['String']['output'];
  unreadMessageCount: Scalars['Int']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export enum DayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type DeleteCommentResponse = {
  __typename?: 'DeleteCommentResponse';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteEmojiResponse = {
  __typename?: 'DeleteEmojiResponse';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteResponse = {
  __typename?: 'DeleteResponse';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteTeamEventResponse = {
  __typename?: 'DeleteTeamEventResponse';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteTeamFileResponse = {
  __typename?: 'DeleteTeamFileResponse';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteTeamPlayerResponse = {
  __typename?: 'DeleteTeamPlayerResponse';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type EmailError = {
  __typename?: 'EmailError';
  email?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
};

export type Emoji = {
  __typename?: 'Emoji';
  createdAt: Scalars['DateTime']['output'];
  emoji: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  modelId: Scalars['String']['output'];
  modelType: SocialModelType;
  name: Scalars['String']['output'];
  user: PublicUser;
  userId: Scalars['String']['output'];
};

export type EmojiInput = {
  emoji: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export enum EntitlementStatus {
  Active = 'ACTIVE',
  GracePeriod = 'GRACE_PERIOD',
  Inactive = 'INACTIVE'
}

export type EventAttendance = {
  __typename?: 'EventAttendance';
  going: Array<Maybe<User>>;
  maybe: Array<Maybe<User>>;
  notAnswer: Array<Maybe<User>>;
  notGoing: Array<Maybe<User>>;
};

export type EventConfirmationInput = {
  eventId: Scalars['String']['input'];
  going?: InputMaybe<Scalars['Boolean']['input']>;
  presenceStatus?: InputMaybe<PresenceStatus>;
  source?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AttendanceStatus>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type EventPushData = {
  __typename?: 'EventPushData';
  eventId: Scalars['String']['output'];
  teamId: Scalars['String']['output'];
};

export enum EventType {
  CoachPractice = 'COACH_PRACTICE',
  CustomEvent = 'CUSTOM_EVENT',
  Game = 'GAME',
  Practice = 'PRACTICE'
}

export type FeedPost = {
  __typename?: 'FeedPost';
  archived: Scalars['Boolean']['output'];
  bookmarkCount: Scalars['Int']['output'];
  carouselImageUrls: Array<Scalars['String']['output']>;
  category: FeedPostCategory;
  categoryId?: Maybe<Scalars['Int']['output']>;
  commentCount: Scalars['Int']['output'];
  contentSource: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  imageUrl: Scalars['String']['output'];
  isPublic: Scalars['Boolean']['output'];
  likeCount: Scalars['Int']['output'];
  mediaType: FeedPostMediaType;
  seenCount: Scalars['Int']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  user: PublicUser;
  userId: Scalars['String']['output'];
};

export enum FeedPostCategory {
  InjuryAndNutrition = 'INJURY_AND_NUTRITION',
  KeepDreaming = 'KEEP_DREAMING',
  Professionals = 'PROFESSIONALS',
  SoccerNow = 'SOCCER_NOW',
  TacticalEdge = 'TACTICAL_EDGE',
  TheSpotlight = 'THE_SPOTLIGHT',
  TipsAndTricks = 'TIPS_AND_TRICKS',
  TrainingAdvice = 'TRAINING_ADVICE',
  TrendingNow = 'TRENDING_NOW',
  Tst_2024 = 'TST_2024',
  UltrainInsider = 'ULTRAIN_INSIDER'
}

export type FeedPostFilter = {
  category?: InputMaybe<FeedPostCategory>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  collectionId?: InputMaybe<Scalars['Int']['input']>;
  saved?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type FeedPostFilters = {
  feedPost?: InputMaybe<Array<FilterConditionInput>>;
  following?: InputMaybe<Scalars['Boolean']['input']>;
  saved?: InputMaybe<Scalars['Boolean']['input']>;
  savedItem?: InputMaybe<Array<FilterConditionInput>>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type FeedPostInput = {
  carouselImageUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  category: FeedPostCategory;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  contentSource: Scalars['String']['input'];
  description: Scalars['String']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  mediaType?: InputMaybe<FeedPostMediaType>;
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
};

export enum FeedPostMediaType {
  ImageCarousel = 'IMAGE_CAROUSEL',
  Video = 'VIDEO'
}

export type FeedPostPushData = {
  __typename?: 'FeedPostPushData';
  feedPostId: Scalars['String']['output'];
};

export type FilterConditionGroupInput = {
  conditions?: InputMaybe<Array<FilterConditionInput>>;
  field?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<FilterOperator>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterConditionInput = {
  field: Scalars['String']['input'];
  operator: FilterOperator;
  value: Scalars['JSON']['input'];
};

export enum FilterOperator {
  And = 'AND',
  ArrayContains = 'ARRAY_CONTAINS',
  Between = 'BETWEEN',
  EndWith = 'END_WITH',
  Eq = 'EQ',
  Gt = 'GT',
  Gte = 'GTE',
  In = 'IN',
  IsFalse = 'IS_FALSE',
  IsNull = 'IS_NULL',
  IsTrue = 'IS_TRUE',
  Like = 'LIKE',
  Lt = 'LT',
  Lte = 'LTE',
  Ne = 'NE',
  NotBetween = 'NOT_BETWEEN',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
  NotNull = 'NOT_NULL',
  Or = 'OR',
  StartWith = 'START_WITH'
}

export type LastActivity = {
  __typename?: 'LastActivity';
  date?: Maybe<Scalars['DateTime']['output']>;
};

export type Like = {
  __typename?: 'Like';
  bookmarked: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  liked: Scalars['Boolean']['output'];
  modelId: Scalars['String']['output'];
  modelType: SocialModelType;
  userId: Scalars['String']['output'];
};

export type LikeInput = {
  bookmarked: Scalars['Boolean']['input'];
  liked: Scalars['Boolean']['input'];
};

export enum LineupConfiguration {
  FiveFourOne = 'FIVE_FOUR_ONE',
  FiveThreeTwo = 'FIVE_THREE_TWO',
  FourFiveOne = 'FOUR_FIVE_ONE',
  FourFourTwo = 'FOUR_FOUR_TWO',
  FourOneTwoOneTwo = 'FOUR_ONE_TWO_ONE_TWO',
  FourThreeThree = 'FOUR_THREE_THREE',
  FourTwoThreeOne = 'FOUR_TWO_THREE_ONE',
  OneTwoTwo = 'ONE_TWO_TWO',
  ThreeFiveTwo = 'THREE_FIVE_TWO',
  ThreeFourThree = 'THREE_FOUR_THREE',
  ThreeFourTwoOne = 'THREE_FOUR_TWO_ONE',
  ThreeTwoOne = 'THREE_TWO_ONE',
  TwoOneTwo = 'TWO_ONE_TWO',
  TwoThreeOne = 'TWO_THREE_ONE',
  TwoTwoOne = 'TWO_TWO_ONE'
}

export type LineupPushData = {
  __typename?: 'LineupPushData';
  lineupId: Scalars['String']['output'];
  teamId: Scalars['String']['output'];
};

export type Link = {
  __typename?: 'Link';
  archived: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  groupId?: Maybe<Scalars['String']['output']>;
  groupType?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  link: Scalars['String']['output'];
  modelId: Scalars['String']['output'];
  modelType: SocialModelType;
  updatedAt: Scalars['DateTime']['output'];
};

export type LinkTeamParentChildInput = {
  childTeamPlayerId: Scalars['Int']['input'];
  parentTeamPlayerId: Scalars['Int']['input'];
};

export type LiveStream = {
  __typename?: 'LiveStream';
  archived: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  endDate: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  imageUrl: Scalars['String']['output'];
  jwtToken?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
  zoomId?: Maybe<Scalars['String']['output']>;
  zoomPassword?: Maybe<Scalars['String']['output']>;
};

export type LiveStreamInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  description: Scalars['String']['input'];
  endDate: Scalars['DateTime']['input'];
  imageUrl: Scalars['String']['input'];
  startDate: Scalars['DateTime']['input'];
  title: Scalars['String']['input'];
  zoomId?: InputMaybe<Scalars['String']['input']>;
  zoomPassword?: InputMaybe<Scalars['String']['input']>;
};

export type LoginResponse = {
  __typename?: 'LoginResponse';
  relatedTokens: Array<Scalars['String']['output']>;
  token: Scalars['String']['output'];
  user: User;
};

export type MaxPhoneNumber = {
  __typename?: 'MaxPhoneNumber';
  next?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  original?: Maybe<Scalars['String']['output']>;
};

export type MessagePushData = {
  __typename?: 'MessagePushData';
  coachUserId: Scalars['String']['output'];
  count: Scalars['String']['output'];
  teamId: Scalars['String']['output'];
  type: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type ModifyUserInput = {
  androidPushToken?: InputMaybe<Scalars['String']['input']>;
  appleId?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  coach?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  iosPushToken?: InputMaybe<Scalars['String']['input']>;
  isAdult?: InputMaybe<Scalars['Boolean']['input']>;
  isContentCreator?: InputMaybe<Scalars['Boolean']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  metaData?: InputMaybe<Scalars['JSON']['input']>;
  newsletter?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  paymentToken?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Position>;
  private?: InputMaybe<Scalars['Boolean']['input']>;
  proTeamId?: InputMaybe<Scalars['Int']['input']>;
  pushToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addEventConfirmation: TeamEventsPlayers;
  addProTeam: ProTeam;
  addTeamEventsPlayer: TeamEventsPlayers;
  adminGrantCoachMembership: SubscriptionEventResult;
  adminModifyUser: User;
  adminRevokeCoachMembership: SubscriptionEventResult;
  answer: UserAnswer;
  cancelMyTestCoachMembership: SubscriptionEventResult;
  changePassword: Scalars['Boolean']['output'];
  comment: Comment;
  confirmSmsVerification: Scalars['Boolean']['output'];
  confirmSubscriptionPurchase: SubscriptionEventResult;
  createAccess: Access;
  createActivity: Activity;
  createActivityPlan: ActivityPlan;
  createChat: ChatConversation;
  createChatMessage: ChatMessage;
  createCollection: Collection;
  createFeedPost: FeedPost;
  createLiveStream: LiveStream;
  createPoll: Poll;
  createTeam: Team;
  createTeamAnnouncement: Array<Maybe<TeamAnnouncement>>;
  createTeamEvent: TeamEvent;
  createTeamFile: TeamFile;
  createTeamLineup: TeamLineup;
  createTeamPlayer: TeamPlayer;
  deleteAccount: Scalars['Boolean']['output'];
  deleteActivity: DeleteResponse;
  deleteActivityPlan: DeleteResponse;
  deleteCollection: DeleteResponse;
  deleteComment: DeleteCommentResponse;
  deleteEmoji: DeleteEmojiResponse;
  deleteFeedPost: DeleteResponse;
  deleteMessage: DeleteResponse;
  deleteMyTestCoachMembership: CoachMembershipEntitlement;
  deletePoll: DeleteResponse;
  deleteTeamEvent: DeleteTeamEventResponse;
  deleteTeamFile: DeleteTeamFileResponse;
  deleteTeamPlayer: DeleteTeamPlayerResponse;
  emoji: Emoji;
  forgotPasswordRequest: Scalars['Boolean']['output'];
  generateCode: TeamCode;
  givePlayersInstructions: PlayersInstructionsResponse;
  importNotifications: DeleteResponse;
  like: Like;
  linkTeamParentChild: TeamParentChildLinkResponse;
  login: LoginResponse;
  modifyUser: User;
  ping: Scalars['String']['output'];
  readMessage: DeleteResponse;
  register: LoginResponse;
  remindAboutEvent: Scalars['Int']['output'];
  removeParentControl: RemoveParentControlResponse;
  report: Report;
  resetPassword: Scalars['Boolean']['output'];
  saveItem: SavedItem;
  seen: Seen;
  sendPushAboutFeed: Scalars['Int']['output'];
  sendPushToAll: Scalars['Int']['output'];
  sendSmsVerification: Scalars['Boolean']['output'];
  sendTestEmail: Scalars['Boolean']['output'];
  simulateSubscriptionEvent: SubscriptionEventResult;
  socialAuth: LoginResponse;
  startTestCoachMembership: SubscriptionEventResult;
  trackCampaignLifecycleEvent: Scalars['Boolean']['output'];
  tryCode: TeamPlayer;
  unlinkTeamParentChild: TeamParentChildLinkResponse;
  unsaveItem: DeleteResponse;
  updateAccess: Access;
  updateActivity: Activity;
  updateActivityPlan: ActivityPlan;
  updateAppConfig: Config;
  updateChat: ChatConversation;
  updateCollection: Collection;
  updateFeedPost: FeedPost;
  updateNotification: Notification;
  updateNotificationPreference: NotificationPreference;
  updateTeam: Team;
  updateTeamAnnouncement: TeamAnnouncement;
  updateTeamEvent: TeamEvent;
  updateTeamEventPlayerMetadata: TeamEventsPlayers;
  updateTeamFile: TeamFile;
  updateTeamLineup: TeamLineup;
  updateTeamPlayer: TeamPlayer;
  validateUser: Scalars['Boolean']['output'];
};


export type MutationAddEventConfirmationArgs = {
  input: EventConfirmationInput;
};


export type MutationAddProTeamArgs = {
  input: ProTeamInput;
};


export type MutationAddTeamEventsPlayerArgs = {
  input: TeamEventsPlayerInput;
};


export type MutationAdminGrantCoachMembershipArgs = {
  input: AdminGrantCoachMembershipInput;
};


export type MutationAdminModifyUserArgs = {
  modifyUserInput: AdminModifyUserInput;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAdminRevokeCoachMembershipArgs = {
  input: AdminRevokeCoachMembershipInput;
};


export type MutationAnswerArgs = {
  answerId: Scalars['Int']['input'];
};


export type MutationChangePasswordArgs = {
  changePasswordInput: ChangePasswordInput;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCommentArgs = {
  commentInput: CommentInput;
  modelId: Scalars['String']['input'];
  modelType: SocialModelType;
};


export type MutationConfirmSmsVerificationArgs = {
  code: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};


export type MutationConfirmSubscriptionPurchaseArgs = {
  input: ConfirmSubscriptionPurchaseInput;
};


export type MutationCreateAccessArgs = {
  input: AccessCreateInput;
};


export type MutationCreateActivityArgs = {
  input: ActivityInput;
};


export type MutationCreateActivityPlanArgs = {
  input: ActivityPlanInput;
};


export type MutationCreateChatArgs = {
  input: ChatInput;
};


export type MutationCreateChatMessageArgs = {
  chatMessageInput: ChatMessageInput;
};


export type MutationCreateCollectionArgs = {
  input: CollectionInput;
};


export type MutationCreateFeedPostArgs = {
  input: FeedPostInput;
};


export type MutationCreateLiveStreamArgs = {
  liveStreamInput: LiveStreamInput;
};


export type MutationCreatePollArgs = {
  input: PollInput;
  modelId: Scalars['String']['input'];
  modelType: SocialModelType;
};


export type MutationCreateTeamArgs = {
  input: TeamInput;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateTeamAnnouncementArgs = {
  input: TeamAnnouncementInput;
};


export type MutationCreateTeamEventArgs = {
  input: TeamEventInput;
};


export type MutationCreateTeamFileArgs = {
  input: TeamFileInput;
};


export type MutationCreateTeamLineupArgs = {
  input: TeamLineupInput;
};


export type MutationCreateTeamPlayerArgs = {
  input: TeamPlayerInput;
};


export type MutationDeleteAccountArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteActivityArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteActivityPlanArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCollectionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCommentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEmojiArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFeedPostArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMessageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePollArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTeamEventArgs = {
  changeNextEvents?: InputMaybe<Scalars['Boolean']['input']>;
  eventId: Scalars['String']['input'];
};


export type MutationDeleteTeamFileArgs = {
  videoId: Scalars['String']['input'];
};


export type MutationDeleteTeamPlayerArgs = {
  id: Scalars['String']['input'];
};


export type MutationEmojiArgs = {
  emojiInput: EmojiInput;
  modelId: Scalars['String']['input'];
  modelType: SocialModelType;
};


export type MutationForgotPasswordRequestArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGenerateCodeArgs = {
  teamId: Scalars['String']['input'];
};


export type MutationGivePlayersInstructionsArgs = {
  input: PlayersInstructionsInput;
};


export type MutationImportNotificationsArgs = {
  fileName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationLikeArgs = {
  likeInput: LikeInput;
  modelId: Scalars['String']['input'];
  modelType: SocialModelType;
};


export type MutationLinkTeamParentChildArgs = {
  input: LinkTeamParentChildInput;
};


export type MutationLoginArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  isPassword?: InputMaybe<Scalars['Boolean']['input']>;
  password: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationModifyUserArgs = {
  modifyUserInput: ModifyUserInput;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationReadMessageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRegisterArgs = {
  userInput: UserInput;
};


export type MutationRemindAboutEventArgs = {
  eventId: Scalars['Int']['input'];
  users: Array<Scalars['String']['input']>;
};


export type MutationRemoveParentControlArgs = {
  input: RemoveParentControlInput;
};


export type MutationReportArgs = {
  modelId: Scalars['String']['input'];
  modelType: Scalars['String']['input'];
  reportInput: ReportInput;
};


export type MutationResetPasswordArgs = {
  newPassword: Scalars['String']['input'];
  resetPasswordToken: Scalars['String']['input'];
};


export type MutationSaveItemArgs = {
  input: SavedItemInput;
};


export type MutationSeenArgs = {
  modelId: Scalars['String']['input'];
  modelType: SocialModelType;
};


export type MutationSendPushAboutFeedArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendPushToAllArgs = {
  ids?: InputMaybe<Scalars['String']['input']>;
  owners?: InputMaybe<Scalars['Boolean']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendSmsVerificationArgs = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber: Scalars['String']['input'];
};


export type MutationSendTestEmailArgs = {
  email: Scalars['String']['input'];
  html?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSimulateSubscriptionEventArgs = {
  input: SimulateSubscriptionEventInput;
};


export type MutationSocialAuthArgs = {
  socialId: Scalars['String']['input'];
  token: Scalars['String']['input'];
  type: SocialAuthType;
};


export type MutationStartTestCoachMembershipArgs = {
  input: StartTestCoachMembershipInput;
};


export type MutationTrackCampaignLifecycleEventArgs = {
  input: CampaignLifecycleEventInput;
};


export type MutationTryCodeArgs = {
  code: Scalars['String']['input'];
  joinType?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUnlinkTeamParentChildArgs = {
  input: UnlinkTeamParentChildInput;
};


export type MutationUnsaveItemArgs = {
  input: SavedItemInput;
};


export type MutationUpdateAccessArgs = {
  id: Scalars['Int']['input'];
  metaData?: InputMaybe<Scalars['JSON']['input']>;
  status: AccessStatus;
};


export type MutationUpdateActivityArgs = {
  id: Scalars['ID']['input'];
  input: ActivityUpdateInput;
};


export type MutationUpdateActivityPlanArgs = {
  id: Scalars['ID']['input'];
  input: ActivityPlanUpdateInput;
};


export type MutationUpdateAppConfigArgs = {
  input: AppConfigUpdateInput;
};


export type MutationUpdateChatArgs = {
  id: Scalars['ID']['input'];
  input: ChatUpdateInput;
};


export type MutationUpdateCollectionArgs = {
  id: Scalars['ID']['input'];
  input: CollectionUpdateInput;
};


export type MutationUpdateFeedPostArgs = {
  id: Scalars['ID']['input'];
  input: UpdateFeedPostInput;
};


export type MutationUpdateNotificationArgs = {
  id: Scalars['ID']['input'];
  input: NotificationUpdateInput;
};


export type MutationUpdateNotificationPreferenceArgs = {
  input: NotificationPreferenceInput;
};


export type MutationUpdateTeamArgs = {
  id: Scalars['String']['input'];
  input: UpdateTeamInput;
};


export type MutationUpdateTeamAnnouncementArgs = {
  id: Scalars['Int']['input'];
  input: UpdateTeamAnnouncementInput;
};


export type MutationUpdateTeamEventArgs = {
  changeNextEvents?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  input: UpdateTeamEventInput;
};


export type MutationUpdateTeamEventPlayerMetadataArgs = {
  input: TeamEventPlayerMetadataInput;
};


export type MutationUpdateTeamFileArgs = {
  id: Scalars['String']['input'];
  input: UpdateTeamFileInput;
};


export type MutationUpdateTeamLineupArgs = {
  id: Scalars['String']['input'];
  input: TeamLineupUpdateInput;
};


export type MutationUpdateTeamPlayerArgs = {
  id: Scalars['String']['input'];
  input: UpdateTeamPlayerInput;
};


export type MutationValidateUserArgs = {
  data: ValidateUserInput;
};

export type Notification = {
  __typename?: 'Notification';
  archived: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['Int']['output'];
  language: Scalars['String']['output'];
  model?: Maybe<Scalars['JSON']['output']>;
  modelId?: Maybe<Scalars['String']['output']>;
  modelType?: Maybe<Scalars['String']['output']>;
  reviewed?: Maybe<Scalars['Boolean']['output']>;
  sendAt?: Maybe<Scalars['Date']['output']>;
  sentAt?: Maybe<Scalars['Date']['output']>;
  serviceType: NotificationServiceType;
  status: NotificationStatus;
  template?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userId: Scalars['String']['output'];
};

export type NotificationInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  language: Scalars['String']['input'];
  modelId?: InputMaybe<Scalars['String']['input']>;
  modelType?: InputMaybe<Scalars['String']['input']>;
  sendAt?: InputMaybe<Scalars['Date']['input']>;
  sentAt?: InputMaybe<Scalars['Date']['input']>;
  serviceType: NotificationServiceType;
  status?: InputMaybe<NotificationStatus>;
  template?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export enum NotificationModelType {
  Announcement = 'ANNOUNCEMENT',
  Event = 'EVENT',
  FeedPost = 'FEED_POST',
  Lineup = 'LINEUP',
  Message = 'MESSAGE',
  Poll = 'POLL',
  Team = 'TEAM',
  TeamFile = 'TEAM_FILE',
  TeamPlayer = 'TEAM_PLAYER',
  User = 'USER'
}

export type NotificationPreference = {
  __typename?: 'NotificationPreference';
  anonymousDeviceId?: Maybe<Scalars['String']['output']>;
  archived: Scalars['Boolean']['output'];
  campaignKey?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  notificationType?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  serviceType: NotificationServiceType;
  source?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type NotificationPreferenceInput = {
  anonymousDeviceId?: InputMaybe<Scalars['String']['input']>;
  campaignKey?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  notificationType?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  serviceType: NotificationServiceType;
  source?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export enum NotificationServiceType {
  Email = 'EMAIL',
  Popup = 'POPUP',
  Push = 'PUSH',
  Sms = 'SMS'
}

export enum NotificationStatus {
  Canceled = 'CANCELED',
  Delivered = 'DELIVERED',
  Error = 'ERROR',
  Pending = 'PENDING',
  Sent = 'SENT'
}

export enum NotificationType {
  AnnouncementCreated = 'AnnouncementCreated',
  AnnouncementUpdated = 'AnnouncementUpdated',
  CoachPlayerJoined = 'CoachPlayerJoined',
  Custom = 'Custom',
  EventAttendanceChanged = 'EventAttendanceChanged',
  EventCreated = 'EventCreated',
  EventDeleted = 'EventDeleted',
  EventRemind = 'EventRemind',
  EventRemind_1dGame = 'EventRemind_1d_Game',
  EventRemind_1dPractice = 'EventRemind_1d_Practice',
  EventRemind_1hGame = 'EventRemind_1h_Game',
  EventRemind_1hPractice = 'EventRemind_1h_Practice',
  EventRemind_3dGame = 'EventRemind_3d_Game',
  EventRemind_3dPractice = 'EventRemind_3d_Practice',
  EventRemind_3hGame = 'EventRemind_3h_Game',
  EventRemind_3hPractice = 'EventRemind_3h_Practice',
  EventRemind_7dGame = 'EventRemind_7d_Game',
  EventRemind_7dPractice = 'EventRemind_7d_Practice',
  EventRemind_12hGame = 'EventRemind_12h_Game',
  EventRemind_12hPractice = 'EventRemind_12h_Practice',
  EventRemindTeamMeal = 'EventRemind_TeamMeal',
  EventRemindTeamMeeting = 'EventRemind_TeamMeeting',
  EventRemindWatchFilm = 'EventRemind_WatchFilm',
  EventUpdated = 'EventUpdated',
  FeedPostRemind = 'FeedPostRemind',
  Instructions = 'Instructions',
  LineupPublished = 'LineupPublished',
  MainCoachFirstTeamCreated = 'MainCoachFirstTeamCreated',
  MainCoachNoPlayersCreated = 'MainCoachNoPlayersCreated',
  MainCoachNoTeamCreated = 'MainCoachNoTeamCreated',
  MainCoachTeamCreated = 'MainCoachTeamCreated',
  MainCoachThreePlayersJoined = 'MainCoachThreePlayersJoined',
  ParentControlLinked = 'ParentControlLinked',
  ParentControlRemoved = 'ParentControlRemoved',
  ParentControlUnlinked = 'ParentControlUnlinked',
  PollCreated = 'PollCreated',
  PollUpdated = 'PollUpdated',
  PracticeEvaluationShared = 'PracticeEvaluationShared',
  TeamFeedGameResultPublished = 'TeamFeedGameResultPublished',
  TeamFeedMatchEventsPublished = 'TeamFeedMatchEventsPublished',
  TeamFeedPracticeResultsPublished = 'TeamFeedPracticeResultsPublished',
  TeamFileCreated = 'TeamFileCreated',
  UserRegistered = 'UserRegistered',
  UserRegisteredCoach = 'UserRegistered_Coach',
  UserRegisteredFan = 'UserRegistered_Fan',
  UserRegisteredParent = 'UserRegistered_Parent',
  UserRegisteredPlayer = 'UserRegistered_Player'
}

export type NotificationUpdateInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  modelId?: InputMaybe<Scalars['String']['input']>;
  modelType?: InputMaybe<Scalars['String']['input']>;
  sendAt?: InputMaybe<Scalars['Date']['input']>;
  sentAt?: InputMaybe<Scalars['Date']['input']>;
  serviceType?: InputMaybe<NotificationServiceType>;
  status?: InputMaybe<NotificationStatus>;
  template?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type OrderBy = {
  column: Scalars['String']['input'];
  direction?: InputMaybe<OrderByDirection>;
};

export enum OrderByDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Pagination = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderBy>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type PlayersInstructionsInput = {
  teamId: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type PlayersInstructionsResponse = {
  __typename?: 'PlayersInstructionsResponse';
  teamId: Scalars['String']['output'];
  text: Scalars['String']['output'];
  userIds: Array<Maybe<Scalars['String']['output']>>;
};

export type Poll = {
  __typename?: 'Poll';
  answers: Array<Answer>;
  archived: Scalars['Boolean']['output'];
  commentCount: Scalars['Int']['output'];
  commentDisabled: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  modelId: Scalars['String']['output'];
  modelType: SocialModelType;
  question: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userAnswerCount: Scalars['Int']['output'];
  userId: Scalars['String']['output'];
};

export type PollInput = {
  answers: Array<Scalars['String']['input']>;
  question: Scalars['String']['input'];
};

export type PollPushData = {
  __typename?: 'PollPushData';
  pollId: Scalars['String']['output'];
  teamId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export enum Position {
  Attacker = 'ATTACKER',
  Defender = 'DEFENDER',
  Goalkeeper = 'GOALKEEPER',
  Midfielder = 'MIDFIELDER'
}

export enum PresenceStatus {
  Absent = 'absent',
  Injured = 'injured',
  Present = 'present'
}

export type ProTeam = {
  __typename?: 'ProTeam';
  archived: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  imageUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ProTeamInput = {
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type PublicUser = {
  __typename?: 'PublicUser';
  bio?: Maybe<Scalars['String']['output']>;
  coach: Scalars['Boolean']['output'];
  eventsCount: Scalars['Int']['output'];
  firstName: Scalars['String']['output'];
  followersCount: Scalars['Int']['output'];
  followingCount: Scalars['Int']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  isAdult?: Maybe<Scalars['Boolean']['output']>;
  isContentCreator?: Maybe<Scalars['Boolean']['output']>;
  isPublic: Scalars['Boolean']['output'];
  language: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  likesCount: Scalars['Int']['output'];
  location?: Maybe<Scalars['String']['output']>;
  metaData?: Maybe<Scalars['JSON']['output']>;
  playerNumber?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Position>;
  proTeam?: Maybe<ProTeam>;
  role?: Maybe<Scalars['String']['output']>;
  teamsCoachCount: Scalars['Int']['output'];
  teamsCount: Scalars['Int']['output'];
  timeZone?: Maybe<Scalars['String']['output']>;
  username: Scalars['String']['output'];
};

export type Push = {
  __typename?: 'Push';
  badge?: Maybe<Scalars['String']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PushError = {
  __typename?: 'PushError';
  error?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export enum PushTokenStatus {
  Default = 'default',
  Invalid = 'invalid',
  Valid = 'valid'
}

export enum PushTopic {
  Allusers = 'allusers',
  Stageallusers = 'stageallusers'
}

export type Query = {
  __typename?: 'Query';
  accesses: Array<Access>;
  activities: Array<Activity>;
  activity: Activity;
  activityPlan: ActivityPlan;
  activityPlans: Array<ActivityPlan>;
  adminCoachMembershipSubscriptions: Array<AdminCoachMembershipSubscription>;
  adminFeedPosts: Array<FeedPost>;
  adminLiveStreams: Array<LiveStream>;
  adminMetrics: AdminMetrics;
  adminTeams: Array<Team>;
  adminUsers: Array<User>;
  allowedAuthMethods: AuthMethodsConfig;
  announcements: Array<TeamAnnouncement>;
  appConfigs: Array<Config>;
  categories: Array<Category>;
  chat: ChatConversation;
  chatAttachments: Array<ChatAttachment>;
  chatMessages: Array<ChatMessage>;
  chats: Array<ChatConversation>;
  coachChat: ChatConversation;
  coachMembershipProducts: Array<SubscriptionProduct>;
  collection: Collection;
  collections: Array<Collection>;
  comments: Array<Comment>;
  config?: Maybe<Config>;
  conversationUnreadMessageCount: UnreadMessageCount;
  emojis: Array<Emoji>;
  feedPost: FeedPost;
  feedPostPage: Scalars['Int']['output'];
  feedPosts: Array<FeedPost>;
  files: Array<TeamFile>;
  findMaxPhoneNumber: MaxPhoneNumber;
  likes: Array<Like>;
  links: Array<Link>;
  liveStream: LiveStream;
  liveStreams: Array<LiveStream>;
  me?: Maybe<LoginResponse>;
  myCoachMembership: CoachMembershipEntitlement;
  notificationPreferences: Array<NotificationPreference>;
  notificationUnreadCount: Scalars['Int']['output'];
  notifications: Array<Notification>;
  parentChat: ChatConversation;
  playerChat: ChatConversation;
  polls: Array<Poll>;
  privateChat: ChatConversation;
  proTeams: Array<ProTeam>;
  relatedTokens: Array<Scalars['String']['output']>;
  savedItems: Array<SavedItem>;
  savedPosts: Array<FeedPost>;
  seens: Array<Seen>;
  signUrl: S3SignResponse;
  team: Team;
  teamAnnouncements: Array<TeamAnnouncement>;
  teamChat: ChatConversation;
  teamCurrentLineup?: Maybe<TeamLineup>;
  teamEvent: TeamEvent;
  teamEventTypes: Array<TeamEventType>;
  teamEvents: Array<TeamEvent>;
  teamEventsPlayers: Array<TeamEventsPlayers>;
  teamFiles: Array<TeamFile>;
  teamLineup: TeamLineup;
  teamMembers: Array<TeamMembers>;
  teamNameByCode: TeamName;
  teamPlayers: Array<PublicUser>;
  teams: Array<Team>;
  user: PublicUser;
  userLiked?: Maybe<Like>;
  userTeamEvents: Array<TeamEventsPlayers>;
  version: Scalars['String']['output'];
};


export type QueryActivitiesArgs = {
  filters?: InputMaybe<Array<FilterConditionInput>>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryActivityArgs = {
  activityId: Scalars['Int']['input'];
};


export type QueryActivityPlanArgs = {
  activityPlanId: Scalars['Int']['input'];
};


export type QueryActivityPlansArgs = {
  filters?: InputMaybe<Array<FilterConditionInput>>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryAdminCoachMembershipSubscriptionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SubscriptionStatus>;
};


export type QueryAdminFeedPostsArgs = {
  category: FeedPostCategory;
  pagination?: InputMaybe<Pagination>;
};


export type QueryAdminLiveStreamsArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QueryAdminTeamsArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QueryAdminUsersArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QueryAllowedAuthMethodsArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<AuthMethodsConfigInput>;
  phoneOrEmail?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAnnouncementsArgs = {
  filters?: InputMaybe<Array<FilterConditionInput>>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryCategoriesArgs = {
  filters?: InputMaybe<Array<FilterConditionInput>>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryChatArgs = {
  chatConversationId?: InputMaybe<Scalars['Int']['input']>;
  queryInput?: InputMaybe<QueryInput>;
  teamId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ChatConversationType>;
  users?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryChatAttachmentsArgs = {
  queryInput?: InputMaybe<QueryInput>;
};


export type QueryChatMessagesArgs = {
  chatConversationId: Scalars['ID']['input'];
  filters?: InputMaybe<Array<FilterConditionInput>>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryChatsArgs = {
  filters?: InputMaybe<Array<FilterConditionInput>>;
  pagination?: InputMaybe<Pagination>;
  queryInput?: InputMaybe<QueryInput>;
};


export type QueryCoachChatArgs = {
  teamId: Scalars['String']['input'];
};


export type QueryCollectionArgs = {
  collectionId: Scalars['Int']['input'];
};


export type QueryCollectionsArgs = {
  filters?: InputMaybe<Array<FilterConditionInput>>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryCommentsArgs = {
  modelId: Scalars['String']['input'];
  modelType: SocialModelType;
  pagination?: InputMaybe<Pagination>;
};


export type QueryConfigArgs = {
  key: Scalars['String']['input'];
};


export type QueryEmojisArgs = {
  modelId: Scalars['String']['input'];
  modelType: SocialModelType;
  pagination?: InputMaybe<Pagination>;
};


export type QueryFeedPostArgs = {
  feedPostId: Scalars['Int']['input'];
};


export type QueryFeedPostPageArgs = {
  category?: InputMaybe<FeedPostCategory>;
  feedPostId: Scalars['Int']['input'];
  filter?: InputMaybe<FeedPostFilter>;
  filters?: InputMaybe<FeedPostFilters>;
  pagination: Pagination;
};


export type QueryFeedPostsArgs = {
  category?: InputMaybe<FeedPostCategory>;
  filter?: InputMaybe<FeedPostFilter>;
  filters?: InputMaybe<FeedPostFilters>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryFilesArgs = {
  filters?: InputMaybe<Array<FilterConditionInput>>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryLikesArgs = {
  modelId: Scalars['String']['input'];
  modelType: SocialModelType;
  pagination?: InputMaybe<Pagination>;
};


export type QueryLinksArgs = {
  queryInput?: InputMaybe<QueryInput>;
};


export type QueryLiveStreamArgs = {
  liveStreamId: Scalars['Int']['input'];
};


export type QueryLiveStreamsArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QueryNotificationPreferencesArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNotificationsArgs = {
  filters?: InputMaybe<Array<FilterConditionInput>>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryParentChatArgs = {
  teamId: Scalars['String']['input'];
};


export type QueryPlayerChatArgs = {
  teamId: Scalars['String']['input'];
};


export type QueryPollsArgs = {
  filters?: InputMaybe<Array<FilterConditionInput>>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryPrivateChatArgs = {
  teamId: Scalars['String']['input'];
  userId1: Scalars['String']['input'];
  userId2: Scalars['String']['input'];
};


export type QuerySavedItemsArgs = {
  filters?: InputMaybe<Array<FilterConditionInput>>;
  pagination?: InputMaybe<Pagination>;
};


export type QuerySavedPostsArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySeensArgs = {
  modelId: Scalars['String']['input'];
  modelType: SocialModelType;
  pagination?: InputMaybe<Pagination>;
};


export type QuerySignUrlArgs = {
  contentType: Scalars['String']['input'];
  objectName: Scalars['String']['input'];
};


export type QueryTeamArgs = {
  teamId: Scalars['String']['input'];
};


export type QueryTeamAnnouncementsArgs = {
  pagination?: InputMaybe<Pagination>;
  teamId: Scalars['String']['input'];
};


export type QueryTeamChatArgs = {
  teamId: Scalars['String']['input'];
};


export type QueryTeamCurrentLineupArgs = {
  teamId: Scalars['String']['input'];
};


export type QueryTeamEventArgs = {
  eventId: Scalars['Int']['input'];
};


export type QueryTeamEventsArgs = {
  filters?: InputMaybe<Array<FilterConditionInput>>;
  pagination?: InputMaybe<Pagination>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  teamId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryTeamEventsPlayersArgs = {
  eventId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTeamFilesArgs = {
  pagination?: InputMaybe<Pagination>;
  teamId: Scalars['String']['input'];
};


export type QueryTeamLineupArgs = {
  teamLineupId: Scalars['Int']['input'];
};


export type QueryTeamMembersArgs = {
  teamId: Scalars['String']['input'];
};


export type QueryTeamNameByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryTeamPlayersArgs = {
  teamId: Scalars['String']['input'];
};


export type QueryTeamsArgs = {
  pagination?: InputMaybe<Pagination>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserArgs = {
  userId: Scalars['String']['input'];
};


export type QueryUserLikedArgs = {
  modelId: Scalars['String']['input'];
  modelType: SocialModelType;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserTeamEventsArgs = {
  userId: Scalars['String']['input'];
};

export type QueryInput = {
  filters?: InputMaybe<Array<FilterConditionGroupInput>>;
  pagination?: InputMaybe<Pagination>;
};

export enum ReminderReceiverType {
  All = 'All',
  NotResponded = 'NotResponded'
}

export enum ReminderType {
  High = 'High',
  Low = 'Low',
  Moderate = 'Moderate'
}

export type RemoveParentControlInput = {
  accessId?: InputMaybe<Scalars['Int']['input']>;
  childUserId: Scalars['String']['input'];
  parentUserId?: InputMaybe<Scalars['String']['input']>;
  teamLinks?: InputMaybe<Array<RemoveParentControlTeamLinkInput>>;
};

export type RemoveParentControlResponse = {
  __typename?: 'RemoveParentControlResponse';
  access?: Maybe<Access>;
  childUserId: Scalars['String']['output'];
  parentUserId: Scalars['String']['output'];
  removedTeamLinks: Array<RemovedParentControlTeamLink>;
};

export type RemoveParentControlTeamLinkInput = {
  childTeamPlayerId: Scalars['Int']['input'];
  parentTeamPlayerId: Scalars['Int']['input'];
};

export type RemovedParentControlTeamLink = {
  __typename?: 'RemovedParentControlTeamLink';
  childTeamPlayerId: Scalars['Int']['output'];
  parentTeamPlayerId: Scalars['Int']['output'];
  teamId: Scalars['String']['output'];
};

export type Report = {
  __typename?: 'Report';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  modelId: Scalars['String']['output'];
  modelType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  text: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: PublicUser;
  userId: Scalars['String']['output'];
};

export type ReportInput = {
  text: Scalars['String']['input'];
};

export type S3SignResponse = {
  __typename?: 'S3SignResponse';
  fileKey: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  publicUrl: Scalars['String']['output'];
  signedUrl: Scalars['String']['output'];
};

export type SavedItem = {
  __typename?: 'SavedItem';
  archived: Scalars['Boolean']['output'];
  collectionId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  modelId: Scalars['String']['output'];
  modelType: SocialModelType;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

export type SavedItemInput = {
  collectionId?: InputMaybe<Scalars['Int']['input']>;
  modelId: Scalars['String']['input'];
  modelType: SocialModelType;
};

export type SavedItemUpdateInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Seen = {
  __typename?: 'Seen';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  modelId: Scalars['String']['output'];
  modelType: SocialModelType;
  user: PublicUser;
  userId: Scalars['String']['output'];
};

export type SimulateSubscriptionEventInput = {
  autoRenewing?: InputMaybe<Scalars['Boolean']['input']>;
  basePlanId?: InputMaybe<Scalars['String']['input']>;
  billingPeriod: SubscriptionBillingPeriod;
  cancelAt?: InputMaybe<Scalars['DateTime']['input']>;
  currentPeriodEnd?: InputMaybe<Scalars['DateTime']['input']>;
  currentPeriodStart?: InputMaybe<Scalars['DateTime']['input']>;
  environment?: InputMaybe<SubscriptionEnvironment>;
  eventType: SubscriptionEventType;
  externalCustomerId?: InputMaybe<Scalars['String']['input']>;
  externalEventId: Scalars['String']['input'];
  externalSubscriptionId: Scalars['String']['input'];
  occurredAt?: InputMaybe<Scalars['DateTime']['input']>;
  payload?: InputMaybe<Scalars['JSON']['input']>;
  productId: Scalars['String']['input'];
  provider: SubscriptionProvider;
  userId: Scalars['String']['input'];
};

export enum SocialAuthType {
  Apple = 'apple',
  Facebook = 'facebook',
  Google = 'google'
}

export enum SocialModelType {
  Activity = 'ACTIVITY',
  Announcement = 'ANNOUNCEMENT',
  Chat = 'CHAT',
  Comment = 'COMMENT',
  FeedPost = 'FEED_POST',
  Message = 'MESSAGE',
  Notification = 'NOTIFICATION',
  Poll = 'POLL',
  Team = 'TEAM',
  TeamEvent = 'TEAM_EVENT',
  TeamFile = 'TEAM_FILE',
  User = 'USER'
}

export enum SocialPostType {
  AddCollection = 'ADD_COLLECTION',
  AddWishlist = 'ADD_WISHLIST',
  ProductReview = 'PRODUCT_REVIEW'
}

export type StartTestCoachMembershipInput = {
  billingPeriod: SubscriptionBillingPeriod;
};

export enum SubscriptionBillingPeriod {
  Monthly = 'MONTHLY',
  Yearly = 'YEARLY'
}

export enum SubscriptionEnvironment {
  Production = 'PRODUCTION',
  Sandbox = 'SANDBOX'
}

export type SubscriptionEvent = {
  __typename?: 'SubscriptionEvent';
  environment: SubscriptionEnvironment;
  eventType: SubscriptionEventType;
  externalEventId: Scalars['String']['output'];
  externalSubscriptionId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  occurredAt: Scalars['DateTime']['output'];
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  processingError?: Maybe<Scalars['String']['output']>;
  processingStatus: SubscriptionEventProcessingStatus;
  provider: SubscriptionProvider;
  subscriptionId?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export enum SubscriptionEventProcessingStatus {
  Failed = 'FAILED',
  Ignored = 'IGNORED',
  Processed = 'PROCESSED',
  Received = 'RECEIVED'
}

export type SubscriptionEventResult = {
  __typename?: 'SubscriptionEventResult';
  duplicate: Scalars['Boolean']['output'];
  entitlement: CoachMembershipEntitlement;
  event: SubscriptionEvent;
  ignored: Scalars['Boolean']['output'];
  subscription: CoachMembershipSubscription;
};

export enum SubscriptionEventType {
  Canceled = 'CANCELED',
  ConfirmationReceived = 'CONFIRMATION_RECEIVED',
  Expired = 'EXPIRED',
  GracePeriodStarted = 'GRACE_PERIOD_STARTED',
  Paused = 'PAUSED',
  Purchased = 'PURCHASED',
  Recovered = 'RECOVERED',
  Refunded = 'REFUNDED',
  Renewed = 'RENEWED',
  Revoked = 'REVOKED'
}

export type SubscriptionProduct = {
  __typename?: 'SubscriptionProduct';
  active: Scalars['Boolean']['output'];
  basePlanId?: Maybe<Scalars['String']['output']>;
  billingPeriod: SubscriptionBillingPeriod;
  entitlementKey: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  productId: Scalars['String']['output'];
  provider: SubscriptionProvider;
};

export enum SubscriptionProvider {
  Apple = 'APPLE',
  Google = 'GOOGLE',
  Manual = 'MANUAL',
  Stripe = 'STRIPE'
}

export enum SubscriptionStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Expired = 'EXPIRED',
  GracePeriod = 'GRACE_PERIOD',
  Paused = 'PAUSED',
  Pending = 'PENDING',
  Revoked = 'REVOKED'
}

export enum SubscriptionVerificationStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Verified = 'VERIFIED'
}

export type Team = {
  __typename?: 'Team';
  ageGroup?: Maybe<Scalars['String']['output']>;
  archived: Scalars['Boolean']['output'];
  coach: PublicUser;
  code: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  isHidden: Scalars['Boolean']['output'];
  lastActivity?: Maybe<LastActivity>;
  lineup?: Maybe<TeamLineup>;
  location: Scalars['String']['output'];
  members: Array<TeamPlayer>;
  metaData?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  playerCount: Scalars['Int']['output'];
  polls: Array<Poll>;
  publicImageUrl?: Maybe<Scalars['String']['output']>;
  seasonEnd?: Maybe<Scalars['DateTime']['output']>;
  seasonStart?: Maybe<Scalars['DateTime']['output']>;
  slogan?: Maybe<Scalars['String']['output']>;
  teamAnnouncements: Array<TeamAnnouncement>;
  teamEvents: Array<TeamEvent>;
  teamFiles: Array<TeamFile>;
  teamLineupId?: Maybe<Scalars['Int']['output']>;
  type: TeamType;
  userId: Scalars['String']['output'];
  userRoles: UserRolesInTeam;
};

export type TeamAnnouncement = {
  __typename?: 'TeamAnnouncement';
  archived: Scalars['Boolean']['output'];
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  emojiCount: Scalars['Int']['output'];
  files: Array<Maybe<TeamFile>>;
  id: Scalars['Int']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  poll?: Maybe<Poll>;
  seenCount: Scalars['Int']['output'];
  teamId: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  user: PublicUser;
  userId: Scalars['String']['output'];
};

export type TeamAnnouncementInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  files: Array<InputMaybe<Scalars['Int']['input']>>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  teamId: Array<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TeamCode = {
  __typename?: 'TeamCode';
  code: Scalars['String']['output'];
  teamId: Scalars['String']['output'];
};

export type TeamEvent = {
  __typename?: 'TeamEvent';
  activityPlans: Array<Maybe<ActivityPlan>>;
  archived: Scalars['Boolean']['output'];
  arriveEarly?: Maybe<Scalars['String']['output']>;
  attendance: EventAttendance;
  away?: Maybe<Scalars['Boolean']['output']>;
  calendarEventId?: Maybe<Scalars['String']['output']>;
  commentCount: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  date: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  ends: Scalars['DateTime']['output'];
  groupId?: Maybe<Scalars['Int']['output']>;
  home?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  isDraft?: Maybe<Scalars['Boolean']['output']>;
  location: Scalars['String']['output'];
  locationDetails?: Maybe<Scalars['String']['output']>;
  members: Array<TeamEventsPlayers>;
  notes?: Maybe<Scalars['String']['output']>;
  opponent?: Maybe<Scalars['String']['output']>;
  recurring: TeamEventRecurring;
  recurringUntilDate?: Maybe<Scalars['DateTime']['output']>;
  reminder: TeamEventReminder;
  reminderNotRespondedType?: Maybe<ReminderType>;
  reminderType?: Maybe<ReminderType>;
  seenCount: Scalars['Int']['output'];
  status: TeamEventStatus;
  subtype?: Maybe<TeamEventType>;
  subtypeId?: Maybe<Scalars['Int']['output']>;
  team: Team;
  teamId: Scalars['String']['output'];
  timeZone: Scalars['String']['output'];
  type: EventType;
  undecided?: Maybe<Scalars['Boolean']['output']>;
  user: PublicUser;
  userId: Scalars['String']['output'];
};

export type TeamEventInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  arriveEarly?: InputMaybe<Scalars['String']['input']>;
  away?: InputMaybe<Scalars['Boolean']['input']>;
  calendarEventId?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  date: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  ends: Scalars['DateTime']['input'];
  home?: InputMaybe<Scalars['Boolean']['input']>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  location: Scalars['String']['input'];
  locationDetails?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  opponent?: InputMaybe<Scalars['String']['input']>;
  recurring: TeamEventRecurring;
  recurringUntilDate?: InputMaybe<Scalars['DateTime']['input']>;
  reminder: TeamEventReminder;
  reminderNotRespondedType?: InputMaybe<ReminderType>;
  reminderType?: InputMaybe<ReminderType>;
  status: TeamEventStatus;
  subtypeId?: InputMaybe<Scalars['Int']['input']>;
  teamId: Scalars['String']['input'];
  timeZone: Scalars['String']['input'];
  type: EventType;
  undecided?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TeamEventPlayerMetadataInput = {
  eventId: Scalars['String']['input'];
  metaData?: InputMaybe<Scalars['JSON']['input']>;
  userId: Scalars['String']['input'];
};

export enum TeamEventRecurring {
  Every2Days = 'Every2Days',
  EveryDay = 'EveryDay',
  EveryMonth = 'EveryMonth',
  EveryWeek = 'EveryWeek',
  EveryYear = 'EveryYear',
  None = 'None'
}

export enum TeamEventReminder {
  AtTimeOfEvent = 'AtTimeOfEvent',
  FifteenMinutesBefore = 'FifteenMinutesBefore',
  FiveDaysBefore = 'FiveDaysBefore',
  FiveMinutesBefore = 'FiveMinutesBefore',
  None = 'None',
  OneDayBefore = 'OneDayBefore',
  OneHourBefore = 'OneHourBefore',
  TenDaysBefore = 'TenDaysBefore',
  TenMinutesBefore = 'TenMinutesBefore',
  ThirtyMinutesBefore = 'ThirtyMinutesBefore',
  ThreeDaysBefore = 'ThreeDaysBefore',
  TwoDaysBefore = 'TwoDaysBefore',
  TwoHoursBefore = 'TwoHoursBefore'
}

export enum TeamEventStatus {
  Cancelled = 'CANCELLED',
  Delayed = 'DELAYED',
  None = 'None',
  Postponed = 'POSTPONED'
}

export type TeamEventType = {
  __typename?: 'TeamEventType';
  archived: Scalars['Boolean']['output'];
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  text_icon?: Maybe<Scalars['String']['output']>;
  theme?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: EventType;
  updatedAt: Scalars['DateTime']['output'];
};

export type TeamEventsPlayerInput = {
  eventId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type TeamEventsPlayers = {
  __typename?: 'TeamEventsPlayers';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  eventId: Scalars['String']['output'];
  going?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  metaData?: Maybe<Scalars['JSON']['output']>;
  presenceStatus?: Maybe<PresenceStatus>;
  status?: Maybe<AttendanceStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
  userId: Scalars['String']['output'];
};

export type TeamFile = {
  __typename?: 'TeamFile';
  archived: Scalars['Boolean']['output'];
  commentCount: Scalars['Int']['output'];
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  imageUrl: Scalars['String']['output'];
  likeCount: Scalars['Int']['output'];
  modelId?: Maybe<Scalars['String']['output']>;
  modelType?: Maybe<SocialModelType>;
  seenCount: Scalars['Int']['output'];
  teamId?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: TeamFileType;
  user: PublicUser;
  userId: Scalars['String']['output'];
};

export type TeamFileInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  modelId?: InputMaybe<Scalars['String']['input']>;
  modelType?: InputMaybe<SocialModelType>;
  teamId?: InputMaybe<Scalars['String']['input']>;
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: TeamFileType;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export enum TeamFileType {
  Audio = 'audio',
  File = 'file',
  Image = 'image',
  Video = 'video'
}

export type TeamInput = {
  ageGroup?: InputMaybe<Scalars['String']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isHidden: Scalars['Boolean']['input'];
  location: Scalars['String']['input'];
  metaData?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  seasonEnd?: InputMaybe<Scalars['DateTime']['input']>;
  seasonStart?: InputMaybe<Scalars['DateTime']['input']>;
  slogan?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TeamType>;
};

export type TeamLineup = {
  __typename?: 'TeamLineup';
  archived: Scalars['Boolean']['output'];
  benchPlayerId1?: Maybe<Scalars['String']['output']>;
  benchPlayerId2?: Maybe<Scalars['String']['output']>;
  benchPlayerId3?: Maybe<Scalars['String']['output']>;
  benchPlayerId4?: Maybe<Scalars['String']['output']>;
  benchPlayerId5?: Maybe<Scalars['String']['output']>;
  benchPlayerId6?: Maybe<Scalars['String']['output']>;
  benchPlayerId7?: Maybe<Scalars['String']['output']>;
  benchPlayerId8?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  instructions?: Maybe<Scalars['String']['output']>;
  lineupConfiguration: LineupConfiguration;
  playerId1?: Maybe<Scalars['String']['output']>;
  playerId2?: Maybe<Scalars['String']['output']>;
  playerId3?: Maybe<Scalars['String']['output']>;
  playerId4?: Maybe<Scalars['String']['output']>;
  playerId5?: Maybe<Scalars['String']['output']>;
  playerId6?: Maybe<Scalars['String']['output']>;
  playerId7?: Maybe<Scalars['String']['output']>;
  playerId8?: Maybe<Scalars['String']['output']>;
  playerId9?: Maybe<Scalars['String']['output']>;
  playerId10?: Maybe<Scalars['String']['output']>;
  playerId11?: Maybe<Scalars['String']['output']>;
  positions?: Maybe<Scalars['JSON']['output']>;
  screenshotUrl?: Maybe<Scalars['String']['output']>;
  shirtSet?: Maybe<Scalars['String']['output']>;
  teamId: Scalars['String']['output'];
  theme?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type TeamLineupInput = {
  archived: Scalars['Boolean']['input'];
  benchPlayerId1?: InputMaybe<Scalars['String']['input']>;
  benchPlayerId2?: InputMaybe<Scalars['String']['input']>;
  benchPlayerId3?: InputMaybe<Scalars['String']['input']>;
  benchPlayerId4?: InputMaybe<Scalars['String']['input']>;
  benchPlayerId5?: InputMaybe<Scalars['String']['input']>;
  benchPlayerId6?: InputMaybe<Scalars['String']['input']>;
  benchPlayerId7?: InputMaybe<Scalars['String']['input']>;
  benchPlayerId8?: InputMaybe<Scalars['String']['input']>;
  lineupConfiguration: LineupConfiguration;
  playerId1?: InputMaybe<Scalars['String']['input']>;
  playerId2?: InputMaybe<Scalars['String']['input']>;
  playerId3?: InputMaybe<Scalars['String']['input']>;
  playerId4?: InputMaybe<Scalars['String']['input']>;
  playerId5?: InputMaybe<Scalars['String']['input']>;
  playerId6?: InputMaybe<Scalars['String']['input']>;
  playerId7?: InputMaybe<Scalars['String']['input']>;
  playerId8?: InputMaybe<Scalars['String']['input']>;
  playerId9?: InputMaybe<Scalars['String']['input']>;
  playerId10?: InputMaybe<Scalars['String']['input']>;
  playerId11?: InputMaybe<Scalars['String']['input']>;
  positions?: InputMaybe<Scalars['JSON']['input']>;
  screenshotUrl?: InputMaybe<Scalars['String']['input']>;
  shirtSet?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['String']['input'];
  theme?: InputMaybe<Scalars['String']['input']>;
};

export type TeamLineupUpdateInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  benchPlayerId1?: InputMaybe<Scalars['String']['input']>;
  benchPlayerId2?: InputMaybe<Scalars['String']['input']>;
  benchPlayerId3?: InputMaybe<Scalars['String']['input']>;
  benchPlayerId4?: InputMaybe<Scalars['String']['input']>;
  benchPlayerId5?: InputMaybe<Scalars['String']['input']>;
  benchPlayerId6?: InputMaybe<Scalars['String']['input']>;
  benchPlayerId7?: InputMaybe<Scalars['String']['input']>;
  benchPlayerId8?: InputMaybe<Scalars['String']['input']>;
  lineupConfiguration?: InputMaybe<LineupConfiguration>;
  playerId1?: InputMaybe<Scalars['String']['input']>;
  playerId2?: InputMaybe<Scalars['String']['input']>;
  playerId3?: InputMaybe<Scalars['String']['input']>;
  playerId4?: InputMaybe<Scalars['String']['input']>;
  playerId5?: InputMaybe<Scalars['String']['input']>;
  playerId6?: InputMaybe<Scalars['String']['input']>;
  playerId7?: InputMaybe<Scalars['String']['input']>;
  playerId8?: InputMaybe<Scalars['String']['input']>;
  playerId9?: InputMaybe<Scalars['String']['input']>;
  playerId10?: InputMaybe<Scalars['String']['input']>;
  playerId11?: InputMaybe<Scalars['String']['input']>;
  positions?: InputMaybe<Scalars['JSON']['input']>;
  screenshotUrl?: InputMaybe<Scalars['String']['input']>;
  shirtSet?: InputMaybe<Scalars['String']['input']>;
  theme?: InputMaybe<Scalars['String']['input']>;
};

export type TeamMembers = {
  __typename?: 'TeamMembers';
  archived: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  improvement?: Maybe<Scalars['String']['output']>;
  isAssistant: Scalars['Boolean']['output'];
  isCaptain: Scalars['Boolean']['output'];
  isCoach: Scalars['Boolean']['output'];
  isParent: Scalars['Boolean']['output'];
  isPlayer: Scalars['Boolean']['output'];
  isViceCaptain: Scalars['Boolean']['output'];
  level?: Maybe<Scalars['String']['output']>;
  playerNumber?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Position>;
  status: TeamPlayerStatus;
  team?: Maybe<Scalars['String']['output']>;
  teamId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<PublicUser>;
  userId: Scalars['String']['output'];
};

export type TeamName = {
  __typename?: 'TeamName';
  name: Scalars['String']['output'];
};

export type TeamParentChildLinkResponse = {
  __typename?: 'TeamParentChildLinkResponse';
  access?: Maybe<Access>;
  parent: TeamPlayer;
};

export type TeamPlayer = {
  __typename?: 'TeamPlayer';
  archived: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  improvement?: Maybe<Scalars['String']['output']>;
  isAssistant: Scalars['Boolean']['output'];
  isCaptain: Scalars['Boolean']['output'];
  isCoach: Scalars['Boolean']['output'];
  isParent: Scalars['Boolean']['output'];
  isPlayer: Scalars['Boolean']['output'];
  isViceCaptain: Scalars['Boolean']['output'];
  joinType?: Maybe<Scalars['String']['output']>;
  level?: Maybe<Scalars['String']['output']>;
  playerNumber?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Position>;
  status: TeamPlayerStatus;
  team?: Maybe<Scalars['String']['output']>;
  teamId: Scalars['String']['output'];
  user?: Maybe<PublicUser>;
  userId: Scalars['String']['output'];
};

export type TeamPlayerInput = {
  archived: Scalars['Boolean']['input'];
  fullName?: InputMaybe<Scalars['String']['input']>;
  improvement?: InputMaybe<Scalars['String']['input']>;
  isAssistant: Scalars['Boolean']['input'];
  isCaptain?: InputMaybe<Scalars['Boolean']['input']>;
  isCoach: Scalars['Boolean']['input'];
  isParent?: InputMaybe<Scalars['Boolean']['input']>;
  isPlayer?: InputMaybe<Scalars['Boolean']['input']>;
  isViceCaptain?: InputMaybe<Scalars['Boolean']['input']>;
  joinType?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  playerNumber?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Position>;
  status?: InputMaybe<TeamPlayerStatus>;
  team?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export enum TeamPlayerStatus {
  Available = 'AVAILABLE',
  Injured = 'INJURED',
  NotAvailable = 'NOT_AVAILABLE'
}

export type TeamPushData = {
  __typename?: 'TeamPushData';
  teamId: Scalars['String']['output'];
};

export enum TeamType {
  Community = 'community',
  Team = 'team'
}

export type UnlinkTeamParentChildInput = {
  childTeamPlayerId: Scalars['Int']['input'];
  parentTeamPlayerId: Scalars['Int']['input'];
};

export type UnreadMessageCount = {
  __typename?: 'UnreadMessageCount';
  conversationsUnreadMessageCount?: Maybe<Array<Maybe<ConversationUnreadMessageCount>>>;
  totalUnreadMessageCount: Scalars['Int']['output'];
};

export type UpdateFeedPostInput = {
  carouselImageUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  category?: InputMaybe<FeedPostCategory>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  contentSource?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  mediaType?: InputMaybe<FeedPostMediaType>;
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTeamAnnouncementInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  files: Array<InputMaybe<Scalars['Int']['input']>>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTeamEventInput = {
  arriveEarly?: InputMaybe<Scalars['String']['input']>;
  away?: InputMaybe<Scalars['Boolean']['input']>;
  calendarEventId?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  ends?: InputMaybe<Scalars['DateTime']['input']>;
  groupId?: InputMaybe<Scalars['Int']['input']>;
  home?: InputMaybe<Scalars['Boolean']['input']>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  locationDetails?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  opponent?: InputMaybe<Scalars['String']['input']>;
  recurring?: InputMaybe<TeamEventRecurring>;
  recurringUntilDate?: InputMaybe<Scalars['DateTime']['input']>;
  reminder?: InputMaybe<TeamEventReminder>;
  reminderNotRespondedType?: InputMaybe<ReminderType>;
  reminderType?: InputMaybe<ReminderType>;
  status?: InputMaybe<TeamEventStatus>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  undecided?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateTeamFileInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTeamInput = {
  ageGroup?: InputMaybe<Scalars['String']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isHidden: Scalars['Boolean']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  metaData?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  seasonEnd?: InputMaybe<Scalars['DateTime']['input']>;
  seasonStart?: InputMaybe<Scalars['DateTime']['input']>;
  slogan?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTeamPlayerInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  improvement?: InputMaybe<Scalars['String']['input']>;
  isAssistant?: InputMaybe<Scalars['Boolean']['input']>;
  isCaptain?: InputMaybe<Scalars['Boolean']['input']>;
  isCoach?: InputMaybe<Scalars['Boolean']['input']>;
  isParent?: InputMaybe<Scalars['Boolean']['input']>;
  isPlayer?: InputMaybe<Scalars['Boolean']['input']>;
  isViceCaptain?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  playerNumber?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Position>;
  status?: InputMaybe<TeamPlayerStatus>;
  team?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  __typename?: 'User';
  admin: Scalars['Boolean']['output'];
  androidPushToken?: Maybe<Scalars['String']['output']>;
  appleId?: Maybe<Scalars['String']['output']>;
  archived: Scalars['Boolean']['output'];
  bio?: Maybe<Scalars['String']['output']>;
  coach: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  eventsCount: Scalars['Int']['output'];
  facebookId?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  followersCount: Scalars['Int']['output'];
  followingCount: Scalars['Int']['output'];
  fullName: Scalars['String']['output'];
  googleId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  iosPushToken?: Maybe<Scalars['String']['output']>;
  isAdult?: Maybe<Scalars['Boolean']['output']>;
  isContentCreator?: Maybe<Scalars['Boolean']['output']>;
  isPublic: Scalars['Boolean']['output'];
  language: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  likesCount: Scalars['Int']['output'];
  location?: Maybe<Scalars['String']['output']>;
  metaData?: Maybe<Scalars['JSON']['output']>;
  newsletter: Scalars['Boolean']['output'];
  paymentToken?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Position>;
  proTeam?: Maybe<ProTeam>;
  proTeamId?: Maybe<Scalars['Int']['output']>;
  pushToken?: Maybe<Scalars['String']['output']>;
  pushTokenStatus?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  teamsCoachCount: Scalars['Int']['output'];
  teamsCount: Scalars['Int']['output'];
  timeZone?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  verified: Scalars['Boolean']['output'];
};

export type UserAnswer = {
  __typename?: 'UserAnswer';
  answerId: Scalars['Int']['output'];
  archived: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  pollId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: PublicUser;
  userId: Scalars['String']['output'];
};

export type UserInput = {
  appleId?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  coach?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  facebookId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isAdult?: InputMaybe<Scalars['Boolean']['input']>;
  isContentCreator?: InputMaybe<Scalars['Boolean']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  metaData?: InputMaybe<Scalars['JSON']['input']>;
  newsletter?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  paymentToken?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Position>;
  private?: InputMaybe<Scalars['Boolean']['input']>;
  proTeamId?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UserRolesInTeam = {
  __typename?: 'UserRolesInTeam';
  isAssistant: Scalars['Boolean']['output'];
  isCaptain: Scalars['Boolean']['output'];
  isCoach: Scalars['Boolean']['output'];
  isCoachOrAssistant: Scalars['Boolean']['output'];
  isMainCoach: Scalars['Boolean']['output'];
  isParent: Scalars['Boolean']['output'];
  isPlayer: Scalars['Boolean']['output'];
  isViceCaptain: Scalars['Boolean']['output'];
};

export type ValidateUserInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type SignUrlQueryVariables = Exact<{
  objectName: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
}>;


export type SignUrlQuery = { __typename?: 'Query', signUrl: { __typename?: 'S3SignResponse', signedUrl: string, publicUrl: string, fileName: string, fileKey: string } };

export type AdminAppConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminAppConfigsQuery = { __typename?: 'Query', appConfigs: Array<{ __typename?: 'Config', id: number, key: string, data: any, archived: boolean, createdAt?: any | undefined, updatedAt?: any | undefined }> };

export type UpdateAppConfigMutationVariables = Exact<{
  input: AppConfigUpdateInput;
}>;


export type UpdateAppConfigMutation = { __typename?: 'Mutation', updateAppConfig: { __typename?: 'Config', id: number, key: string, data: any, archived: boolean, createdAt?: any | undefined, updatedAt?: any | undefined } };

export type AdminMetricsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminMetricsQuery = { __typename?: 'Query', adminMetrics: { __typename?: 'AdminMetrics', userCount: number, feedPostCount: number, teamCount: number, liveStreamCount: number, usageCards: Array<{ __typename?: 'AdminUsageMetric', key: string, label: string, faIcon: string, color: string, total: number, quarter: { __typename?: 'AdminMetricPeriod', count: number, previousCount: number, percentChange?: number | undefined }, month: { __typename?: 'AdminMetricPeriod', count: number, previousCount: number, percentChange?: number | undefined }, week: { __typename?: 'AdminMetricPeriod', count: number, previousCount: number, percentChange?: number | undefined }, day: { __typename?: 'AdminMetricPeriod', count: number, previousCount: number, percentChange?: number | undefined } }> } };

export type AdminCoachMembershipSubscriptionsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SubscriptionStatus>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AdminCoachMembershipSubscriptionsQuery = { __typename?: 'Query', adminCoachMembershipSubscriptions: Array<{ __typename?: 'AdminCoachMembershipSubscription', user: { __typename?: 'User', id: string, email?: string | undefined, fullName: string, coach: boolean }, subscription: { __typename?: 'CoachMembershipSubscription', id: number, provider: SubscriptionProvider, environment: SubscriptionEnvironment, productId: string, billingPeriod: SubscriptionBillingPeriod, status: SubscriptionStatus, verificationStatus: SubscriptionVerificationStatus, autoRenewing: boolean, currentPeriodStart?: any | undefined, currentPeriodEnd?: any | undefined }, entitlement: { __typename?: 'CoachMembershipEntitlement', status: EntitlementStatus, isActive: boolean, validUntil?: any | undefined, subscription?: { __typename?: 'CoachMembershipSubscription', id: number } | undefined } }> };

export type AdminGrantCoachMembershipMutationVariables = Exact<{
  input: AdminGrantCoachMembershipInput;
}>;


export type AdminGrantCoachMembershipMutation = { __typename?: 'Mutation', adminGrantCoachMembership: { __typename?: 'SubscriptionEventResult', subscription: { __typename?: 'CoachMembershipSubscription', id: number }, entitlement: { __typename?: 'CoachMembershipEntitlement', isActive: boolean } } };

export type AdminRevokeCoachMembershipMutationVariables = Exact<{
  input: AdminRevokeCoachMembershipInput;
}>;


export type AdminRevokeCoachMembershipMutation = { __typename?: 'Mutation', adminRevokeCoachMembership: { __typename?: 'SubscriptionEventResult', subscription: { __typename?: 'CoachMembershipSubscription', id: number }, entitlement: { __typename?: 'CoachMembershipEntitlement', isActive: boolean } } };

export type AdminUsersQueryVariables = Exact<{
  pagination?: InputMaybe<Pagination>;
}>;


export type AdminUsersQuery = { __typename?: 'Query', adminUsers: Array<{ __typename?: 'User', id: string, email?: string | undefined, phoneNumber?: string | undefined, fullName: string, admin: boolean, coach: boolean, location?: string | undefined, imageUrl?: string | undefined, position?: Position | undefined, verified: boolean, role?: string | undefined, timeZone?: string | undefined, archived: boolean, createdAt?: any | undefined }> };

export type AdminFeedPostsQueryVariables = Exact<{
  pagination?: InputMaybe<Pagination>;
  category: FeedPostCategory;
}>;


export type AdminFeedPostsQuery = { __typename?: 'Query', adminFeedPosts: Array<{ __typename?: 'FeedPost', id: number, userId: string, imageUrl: string, thumbnailUrl?: string | undefined, mediaType: FeedPostMediaType, carouselImageUrls: Array<string>, category: FeedPostCategory, contentSource: string, description: string, createdAt?: any | undefined, archived: boolean, isPublic: boolean, categoryId?: number | undefined, likeCount: number, commentCount: number, bookmarkCount: number, user: { __typename?: 'PublicUser', id: string, fullName: string } }> };

export type CreateFeedPostMutationVariables = Exact<{
  input: FeedPostInput;
}>;


export type CreateFeedPostMutation = { __typename?: 'Mutation', createFeedPost: { __typename?: 'FeedPost', id: number } };

export type LiveStreamQueryVariables = Exact<{
  liveStreamId: Scalars['Int']['input'];
}>;


export type LiveStreamQuery = { __typename?: 'Query', liveStream: { __typename?: 'LiveStream', id: number, imageUrl: string, zoomId?: string | undefined, zoomPassword?: string | undefined, startDate: any, endDate: any, title: string, description: string, archived: boolean, createdAt: any, jwtToken?: string | undefined } };

export type AdminLiveStreamsQueryVariables = Exact<{
  pagination?: InputMaybe<Pagination>;
}>;


export type AdminLiveStreamsQuery = { __typename?: 'Query', adminLiveStreams: Array<{ __typename?: 'LiveStream', id: number, imageUrl: string, zoomId?: string | undefined, startDate: any, endDate: any, title: string, description: string, archived: boolean, createdAt: any }> };

export type CreateLiveStreamMutationVariables = Exact<{
  liveStreamInput: LiveStreamInput;
}>;


export type CreateLiveStreamMutation = { __typename?: 'Mutation', createLiveStream: { __typename?: 'LiveStream', id: number } };

export type ProTeamsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProTeamsQuery = { __typename?: 'Query', proTeams: Array<{ __typename?: 'ProTeam', id: number, imageUrl: string, name: string, archived: boolean }> };

export type AddProTeamMutationVariables = Exact<{
  input: ProTeamInput;
}>;


export type AddProTeamMutation = { __typename?: 'Mutation', addProTeam: { __typename?: 'ProTeam', id: number } };

export type AdminTeamsQueryVariables = Exact<{
  pagination?: InputMaybe<Pagination>;
}>;


export type AdminTeamsQuery = { __typename?: 'Query', adminTeams: Array<{ __typename?: 'Team', id: string, name: string, code: string, location: string, createdAt?: any | undefined, playerCount: number, archived: boolean, coach: { __typename?: 'PublicUser', id: string, fullName: string } }> };

export type TeamNameByCodeQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type TeamNameByCodeQuery = { __typename?: 'Query', teamNameByCode: { __typename?: 'TeamName', name: string } };

export type AddEventConfirmationMutationVariables = Exact<{
  input: EventConfirmationInput;
}>;


export type AddEventConfirmationMutation = { __typename?: 'Mutation', addEventConfirmation: { __typename?: 'TeamEventsPlayers', id: number, userId: string, eventId: string, createdAt?: any | undefined, updatedAt?: any | undefined, going?: boolean | undefined, status?: AttendanceStatus | undefined } };

export type GenericUserFieldsFragment = { __typename?: 'User', id: string, firstName: string, lastName: string, fullName: string, email?: string | undefined, phoneNumber?: string | undefined, admin: boolean, createdAt?: any | undefined };

export type CurrentUserFieldsFragment = { __typename?: 'User', id: string, firstName: string, lastName: string, fullName: string, email?: string | undefined, phoneNumber?: string | undefined, admin: boolean, createdAt?: any | undefined };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'LoginResponse', token: string, user: { __typename?: 'User', id: string, firstName: string, lastName: string, fullName: string, email?: string | undefined, phoneNumber?: string | undefined, admin: boolean, createdAt?: any | undefined } } | undefined };

export type LoginMutationVariables = Exact<{
  phone: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'LoginResponse', token: string, user: { __typename?: 'User', id: string, firstName: string, lastName: string, fullName: string, email?: string | undefined, phoneNumber?: string | undefined, admin: boolean, createdAt?: any | undefined } } };

export type RegisterMutationVariables = Exact<{
  userInput: UserInput;
}>;


export type RegisterMutation = { __typename?: 'Mutation', register: { __typename?: 'LoginResponse', token: string, user: { __typename?: 'User', id: string, firstName: string, lastName: string, fullName: string, email?: string | undefined, phoneNumber?: string | undefined, admin: boolean, createdAt?: any | undefined } } };

export type AdminModifyUserMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['String']['input']>;
  modifyUserInput: AdminModifyUserInput;
}>;


export type AdminModifyUserMutation = { __typename?: 'Mutation', adminModifyUser: { __typename?: 'User', id: string, firstName: string, lastName: string, fullName: string, email?: string | undefined, phoneNumber?: string | undefined, admin: boolean, createdAt?: any | undefined } };

export type DeleteFeedPostMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteFeedPostMutation = { __typename?: 'Mutation', deleteFeedPost: { __typename?: 'DeleteResponse', success?: boolean | undefined, message?: string | undefined } };

export type UpdateFeedPostMutationVariables = Exact<{
  updateFeedPostId: Scalars['ID']['input'];
  input: UpdateFeedPostInput;
}>;


export type UpdateFeedPostMutation = { __typename?: 'Mutation', updateFeedPost: { __typename?: 'FeedPost', id: number, imageUrl: string, category: FeedPostCategory, contentSource: string, description: string, createdAt?: any | undefined, archived: boolean, likeCount: number, commentCount: number, bookmarkCount: number, categoryId?: number | undefined } };

export type SendPushToAllMutationVariables = Exact<{
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  owners?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Scalars['String']['input']>;
}>;


export type SendPushToAllMutation = { __typename?: 'Mutation', sendPushToAll: number };

export type SendPushAboutFeedMutationVariables = Exact<{
  text?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SendPushAboutFeedMutation = { __typename?: 'Mutation', sendPushAboutFeed: number };

export type SendTestEmailMutationVariables = Exact<{
  email: Scalars['String']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
  html?: InputMaybe<Scalars['String']['input']>;
}>;


export type SendTestEmailMutation = { __typename?: 'Mutation', sendTestEmail: boolean };

export type FeedPostQueryVariables = Exact<{
  feedPostId: Scalars['Int']['input'];
}>;


export type FeedPostQuery = { __typename?: 'Query', feedPost: { __typename?: 'FeedPost', id: number, imageUrl: string, thumbnailUrl?: string | undefined, description: string, category: FeedPostCategory, categoryId?: number | undefined } };

export type CategoriesQueryVariables = Exact<{
  filters?: InputMaybe<Array<FilterConditionInput> | FilterConditionInput>;
  pagination?: InputMaybe<Pagination>;
}>;


export type CategoriesQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'Category', archived: boolean, createdAt: any, description?: string | undefined, forCoach: boolean, forFeed: boolean, id: number, name?: string | undefined, title: string, updatedAt: any }> };

export type ImportNotificationsMutationVariables = Exact<{
  fileName?: InputMaybe<Scalars['String']['input']>;
}>;


export type ImportNotificationsMutation = { __typename?: 'Mutation', importNotifications: { __typename?: 'DeleteResponse', message?: string | undefined, success?: boolean | undefined } };

export const GenericUserFieldsFragmentDoc = gql`
    fragment GenericUserFields on User {
  id
  firstName
  lastName
  fullName
  email
  phoneNumber
  admin
  createdAt
}
    `;
export const CurrentUserFieldsFragmentDoc = gql`
    fragment CurrentUserFields on User {
  ...GenericUserFields
}
    ${GenericUserFieldsFragmentDoc}`;
export const SignUrlDocument = gql`
    query SignUrl($objectName: String!, $contentType: String!) {
  signUrl(objectName: $objectName, contentType: $contentType) {
    signedUrl
    publicUrl
    fileName
    fileKey
  }
}
    `;

/**
 * __useSignUrlQuery__
 *
 * To run a query within a React component, call `useSignUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignUrlQuery({
 *   variables: {
 *      objectName: // value for 'objectName'
 *      contentType: // value for 'contentType'
 *   },
 * });
 */
export function useSignUrlQuery(baseOptions: Apollo.QueryHookOptions<SignUrlQuery, SignUrlQueryVariables> & ({ variables: SignUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignUrlQuery, SignUrlQueryVariables>(SignUrlDocument, options);
      }
export function useSignUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignUrlQuery, SignUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignUrlQuery, SignUrlQueryVariables>(SignUrlDocument, options);
        }
// @ts-ignore
export function useSignUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SignUrlQuery, SignUrlQueryVariables>): Apollo.UseSuspenseQueryResult<SignUrlQuery, SignUrlQueryVariables>;
export function useSignUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SignUrlQuery, SignUrlQueryVariables>): Apollo.UseSuspenseQueryResult<SignUrlQuery | undefined, SignUrlQueryVariables>;
export function useSignUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SignUrlQuery, SignUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SignUrlQuery, SignUrlQueryVariables>(SignUrlDocument, options);
        }
export type SignUrlQueryHookResult = ReturnType<typeof useSignUrlQuery>;
export type SignUrlLazyQueryHookResult = ReturnType<typeof useSignUrlLazyQuery>;
export type SignUrlSuspenseQueryHookResult = ReturnType<typeof useSignUrlSuspenseQuery>;
export type SignUrlQueryResult = Apollo.QueryResult<SignUrlQuery, SignUrlQueryVariables>;
export const AdminAppConfigsDocument = gql`
    query AdminAppConfigs {
  appConfigs {
    id
    key
    data
    archived
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useAdminAppConfigsQuery__
 *
 * To run a query within a React component, call `useAdminAppConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminAppConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminAppConfigsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminAppConfigsQuery(baseOptions?: Apollo.QueryHookOptions<AdminAppConfigsQuery, AdminAppConfigsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminAppConfigsQuery, AdminAppConfigsQueryVariables>(AdminAppConfigsDocument, options);
      }
export function useAdminAppConfigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminAppConfigsQuery, AdminAppConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminAppConfigsQuery, AdminAppConfigsQueryVariables>(AdminAppConfigsDocument, options);
        }
// @ts-ignore
export function useAdminAppConfigsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminAppConfigsQuery, AdminAppConfigsQueryVariables>): Apollo.UseSuspenseQueryResult<AdminAppConfigsQuery, AdminAppConfigsQueryVariables>;
export function useAdminAppConfigsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminAppConfigsQuery, AdminAppConfigsQueryVariables>): Apollo.UseSuspenseQueryResult<AdminAppConfigsQuery | undefined, AdminAppConfigsQueryVariables>;
export function useAdminAppConfigsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminAppConfigsQuery, AdminAppConfigsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminAppConfigsQuery, AdminAppConfigsQueryVariables>(AdminAppConfigsDocument, options);
        }
export type AdminAppConfigsQueryHookResult = ReturnType<typeof useAdminAppConfigsQuery>;
export type AdminAppConfigsLazyQueryHookResult = ReturnType<typeof useAdminAppConfigsLazyQuery>;
export type AdminAppConfigsSuspenseQueryHookResult = ReturnType<typeof useAdminAppConfigsSuspenseQuery>;
export type AdminAppConfigsQueryResult = Apollo.QueryResult<AdminAppConfigsQuery, AdminAppConfigsQueryVariables>;
export const UpdateAppConfigDocument = gql`
    mutation UpdateAppConfig($input: AppConfigUpdateInput!) {
  updateAppConfig(input: $input) {
    id
    key
    data
    archived
    createdAt
    updatedAt
  }
}
    `;
export type UpdateAppConfigMutationFn = Apollo.MutationFunction<UpdateAppConfigMutation, UpdateAppConfigMutationVariables>;

/**
 * __useUpdateAppConfigMutation__
 *
 * To run a mutation, you first call `useUpdateAppConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAppConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAppConfigMutation, { data, loading, error }] = useUpdateAppConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAppConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAppConfigMutation, UpdateAppConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAppConfigMutation, UpdateAppConfigMutationVariables>(UpdateAppConfigDocument, options);
      }
export type UpdateAppConfigMutationHookResult = ReturnType<typeof useUpdateAppConfigMutation>;
export type UpdateAppConfigMutationResult = Apollo.MutationResult<UpdateAppConfigMutation>;
export type UpdateAppConfigMutationOptions = Apollo.BaseMutationOptions<UpdateAppConfigMutation, UpdateAppConfigMutationVariables>;
export const AdminMetricsDocument = gql`
    query AdminMetrics {
  adminMetrics {
    userCount
    feedPostCount
    teamCount
    liveStreamCount
    usageCards {
      key
      label
      faIcon
      color
      total
      quarter {
        count
        previousCount
        percentChange
      }
      month {
        count
        previousCount
        percentChange
      }
      week {
        count
        previousCount
        percentChange
      }
      day {
        count
        previousCount
        percentChange
      }
    }
  }
}
    `;

/**
 * __useAdminMetricsQuery__
 *
 * To run a query within a React component, call `useAdminMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminMetricsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminMetricsQuery(baseOptions?: Apollo.QueryHookOptions<AdminMetricsQuery, AdminMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminMetricsQuery, AdminMetricsQueryVariables>(AdminMetricsDocument, options);
      }
export function useAdminMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminMetricsQuery, AdminMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminMetricsQuery, AdminMetricsQueryVariables>(AdminMetricsDocument, options);
        }
// @ts-ignore
export function useAdminMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminMetricsQuery, AdminMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<AdminMetricsQuery, AdminMetricsQueryVariables>;
export function useAdminMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminMetricsQuery, AdminMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<AdminMetricsQuery | undefined, AdminMetricsQueryVariables>;
export function useAdminMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminMetricsQuery, AdminMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminMetricsQuery, AdminMetricsQueryVariables>(AdminMetricsDocument, options);
        }
export type AdminMetricsQueryHookResult = ReturnType<typeof useAdminMetricsQuery>;
export type AdminMetricsLazyQueryHookResult = ReturnType<typeof useAdminMetricsLazyQuery>;
export type AdminMetricsSuspenseQueryHookResult = ReturnType<typeof useAdminMetricsSuspenseQuery>;
export type AdminMetricsQueryResult = Apollo.QueryResult<AdminMetricsQuery, AdminMetricsQueryVariables>;
export const AdminCoachMembershipSubscriptionsDocument = gql`
    query AdminCoachMembershipSubscriptions($query: String, $status: SubscriptionStatus, $limit: Int) {
  adminCoachMembershipSubscriptions(query: $query, status: $status, limit: $limit) {
    user {
      id
      email
      fullName
      coach
    }
    subscription {
      id
      provider
      environment
      productId
      billingPeriod
      status
      verificationStatus
      autoRenewing
      currentPeriodStart
      currentPeriodEnd
    }
    entitlement {
      status
      isActive
      validUntil
      subscription {
        id
      }
    }
  }
}
    `;

/**
 * __useAdminCoachMembershipSubscriptionsQuery__
 *
 * To run a query within a React component, call `useAdminCoachMembershipSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCoachMembershipSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCoachMembershipSubscriptionsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      status: // value for 'status'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAdminCoachMembershipSubscriptionsQuery(baseOptions?: Apollo.QueryHookOptions<AdminCoachMembershipSubscriptionsQuery, AdminCoachMembershipSubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminCoachMembershipSubscriptionsQuery, AdminCoachMembershipSubscriptionsQueryVariables>(AdminCoachMembershipSubscriptionsDocument, options);
      }
export function useAdminCoachMembershipSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminCoachMembershipSubscriptionsQuery, AdminCoachMembershipSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminCoachMembershipSubscriptionsQuery, AdminCoachMembershipSubscriptionsQueryVariables>(AdminCoachMembershipSubscriptionsDocument, options);
        }
// @ts-ignore
export function useAdminCoachMembershipSubscriptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminCoachMembershipSubscriptionsQuery, AdminCoachMembershipSubscriptionsQueryVariables>): Apollo.UseSuspenseQueryResult<AdminCoachMembershipSubscriptionsQuery, AdminCoachMembershipSubscriptionsQueryVariables>;
export function useAdminCoachMembershipSubscriptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminCoachMembershipSubscriptionsQuery, AdminCoachMembershipSubscriptionsQueryVariables>): Apollo.UseSuspenseQueryResult<AdminCoachMembershipSubscriptionsQuery | undefined, AdminCoachMembershipSubscriptionsQueryVariables>;
export function useAdminCoachMembershipSubscriptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminCoachMembershipSubscriptionsQuery, AdminCoachMembershipSubscriptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminCoachMembershipSubscriptionsQuery, AdminCoachMembershipSubscriptionsQueryVariables>(AdminCoachMembershipSubscriptionsDocument, options);
        }
export type AdminCoachMembershipSubscriptionsQueryHookResult = ReturnType<typeof useAdminCoachMembershipSubscriptionsQuery>;
export type AdminCoachMembershipSubscriptionsLazyQueryHookResult = ReturnType<typeof useAdminCoachMembershipSubscriptionsLazyQuery>;
export type AdminCoachMembershipSubscriptionsSuspenseQueryHookResult = ReturnType<typeof useAdminCoachMembershipSubscriptionsSuspenseQuery>;
export type AdminCoachMembershipSubscriptionsQueryResult = Apollo.QueryResult<AdminCoachMembershipSubscriptionsQuery, AdminCoachMembershipSubscriptionsQueryVariables>;
export const AdminGrantCoachMembershipDocument = gql`
    mutation AdminGrantCoachMembership($input: AdminGrantCoachMembershipInput!) {
  adminGrantCoachMembership(input: $input) {
    subscription {
      id
    }
    entitlement {
      isActive
    }
  }
}
    `;
export type AdminGrantCoachMembershipMutationFn = Apollo.MutationFunction<AdminGrantCoachMembershipMutation, AdminGrantCoachMembershipMutationVariables>;

/**
 * __useAdminGrantCoachMembershipMutation__
 *
 * To run a mutation, you first call `useAdminGrantCoachMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminGrantCoachMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminGrantCoachMembershipMutation, { data, loading, error }] = useAdminGrantCoachMembershipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminGrantCoachMembershipMutation(baseOptions?: Apollo.MutationHookOptions<AdminGrantCoachMembershipMutation, AdminGrantCoachMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminGrantCoachMembershipMutation, AdminGrantCoachMembershipMutationVariables>(AdminGrantCoachMembershipDocument, options);
      }
export type AdminGrantCoachMembershipMutationHookResult = ReturnType<typeof useAdminGrantCoachMembershipMutation>;
export type AdminGrantCoachMembershipMutationResult = Apollo.MutationResult<AdminGrantCoachMembershipMutation>;
export type AdminGrantCoachMembershipMutationOptions = Apollo.BaseMutationOptions<AdminGrantCoachMembershipMutation, AdminGrantCoachMembershipMutationVariables>;
export const AdminRevokeCoachMembershipDocument = gql`
    mutation AdminRevokeCoachMembership($input: AdminRevokeCoachMembershipInput!) {
  adminRevokeCoachMembership(input: $input) {
    subscription {
      id
    }
    entitlement {
      isActive
    }
  }
}
    `;
export type AdminRevokeCoachMembershipMutationFn = Apollo.MutationFunction<AdminRevokeCoachMembershipMutation, AdminRevokeCoachMembershipMutationVariables>;

/**
 * __useAdminRevokeCoachMembershipMutation__
 *
 * To run a mutation, you first call `useAdminRevokeCoachMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminRevokeCoachMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminRevokeCoachMembershipMutation, { data, loading, error }] = useAdminRevokeCoachMembershipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminRevokeCoachMembershipMutation(baseOptions?: Apollo.MutationHookOptions<AdminRevokeCoachMembershipMutation, AdminRevokeCoachMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminRevokeCoachMembershipMutation, AdminRevokeCoachMembershipMutationVariables>(AdminRevokeCoachMembershipDocument, options);
      }
export type AdminRevokeCoachMembershipMutationHookResult = ReturnType<typeof useAdminRevokeCoachMembershipMutation>;
export type AdminRevokeCoachMembershipMutationResult = Apollo.MutationResult<AdminRevokeCoachMembershipMutation>;
export type AdminRevokeCoachMembershipMutationOptions = Apollo.BaseMutationOptions<AdminRevokeCoachMembershipMutation, AdminRevokeCoachMembershipMutationVariables>;
export const AdminUsersDocument = gql`
    query AdminUsers($pagination: Pagination) {
  adminUsers(pagination: $pagination) {
    id
    email
    phoneNumber
    fullName
    admin
    coach
    location
    imageUrl
    position
    verified
    role
    timeZone
    archived
    createdAt
  }
}
    `;

/**
 * __useAdminUsersQuery__
 *
 * To run a query within a React component, call `useAdminUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminUsersQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useAdminUsersQuery(baseOptions?: Apollo.QueryHookOptions<AdminUsersQuery, AdminUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminUsersQuery, AdminUsersQueryVariables>(AdminUsersDocument, options);
      }
export function useAdminUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminUsersQuery, AdminUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminUsersQuery, AdminUsersQueryVariables>(AdminUsersDocument, options);
        }
// @ts-ignore
export function useAdminUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminUsersQuery, AdminUsersQueryVariables>): Apollo.UseSuspenseQueryResult<AdminUsersQuery, AdminUsersQueryVariables>;
export function useAdminUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminUsersQuery, AdminUsersQueryVariables>): Apollo.UseSuspenseQueryResult<AdminUsersQuery | undefined, AdminUsersQueryVariables>;
export function useAdminUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminUsersQuery, AdminUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminUsersQuery, AdminUsersQueryVariables>(AdminUsersDocument, options);
        }
export type AdminUsersQueryHookResult = ReturnType<typeof useAdminUsersQuery>;
export type AdminUsersLazyQueryHookResult = ReturnType<typeof useAdminUsersLazyQuery>;
export type AdminUsersSuspenseQueryHookResult = ReturnType<typeof useAdminUsersSuspenseQuery>;
export type AdminUsersQueryResult = Apollo.QueryResult<AdminUsersQuery, AdminUsersQueryVariables>;
export const AdminFeedPostsDocument = gql`
    query AdminFeedPosts($pagination: Pagination, $category: FeedPostCategory!) {
  adminFeedPosts(category: $category, pagination: $pagination) {
    id
    userId
    imageUrl
    thumbnailUrl
    mediaType
    carouselImageUrls
    category
    contentSource
    description
    createdAt
    archived
    isPublic
    categoryId
    likeCount
    commentCount
    bookmarkCount
    user {
      id
      fullName
    }
  }
}
    `;

/**
 * __useAdminFeedPostsQuery__
 *
 * To run a query within a React component, call `useAdminFeedPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminFeedPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminFeedPostsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      category: // value for 'category'
 *   },
 * });
 */
export function useAdminFeedPostsQuery(baseOptions: Apollo.QueryHookOptions<AdminFeedPostsQuery, AdminFeedPostsQueryVariables> & ({ variables: AdminFeedPostsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminFeedPostsQuery, AdminFeedPostsQueryVariables>(AdminFeedPostsDocument, options);
      }
export function useAdminFeedPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminFeedPostsQuery, AdminFeedPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminFeedPostsQuery, AdminFeedPostsQueryVariables>(AdminFeedPostsDocument, options);
        }
// @ts-ignore
export function useAdminFeedPostsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminFeedPostsQuery, AdminFeedPostsQueryVariables>): Apollo.UseSuspenseQueryResult<AdminFeedPostsQuery, AdminFeedPostsQueryVariables>;
export function useAdminFeedPostsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminFeedPostsQuery, AdminFeedPostsQueryVariables>): Apollo.UseSuspenseQueryResult<AdminFeedPostsQuery | undefined, AdminFeedPostsQueryVariables>;
export function useAdminFeedPostsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminFeedPostsQuery, AdminFeedPostsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminFeedPostsQuery, AdminFeedPostsQueryVariables>(AdminFeedPostsDocument, options);
        }
export type AdminFeedPostsQueryHookResult = ReturnType<typeof useAdminFeedPostsQuery>;
export type AdminFeedPostsLazyQueryHookResult = ReturnType<typeof useAdminFeedPostsLazyQuery>;
export type AdminFeedPostsSuspenseQueryHookResult = ReturnType<typeof useAdminFeedPostsSuspenseQuery>;
export type AdminFeedPostsQueryResult = Apollo.QueryResult<AdminFeedPostsQuery, AdminFeedPostsQueryVariables>;
export const CreateFeedPostDocument = gql`
    mutation CreateFeedPost($input: FeedPostInput!) {
  createFeedPost(input: $input) {
    id
  }
}
    `;
export type CreateFeedPostMutationFn = Apollo.MutationFunction<CreateFeedPostMutation, CreateFeedPostMutationVariables>;

/**
 * __useCreateFeedPostMutation__
 *
 * To run a mutation, you first call `useCreateFeedPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeedPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFeedPostMutation, { data, loading, error }] = useCreateFeedPostMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFeedPostMutation(baseOptions?: Apollo.MutationHookOptions<CreateFeedPostMutation, CreateFeedPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFeedPostMutation, CreateFeedPostMutationVariables>(CreateFeedPostDocument, options);
      }
export type CreateFeedPostMutationHookResult = ReturnType<typeof useCreateFeedPostMutation>;
export type CreateFeedPostMutationResult = Apollo.MutationResult<CreateFeedPostMutation>;
export type CreateFeedPostMutationOptions = Apollo.BaseMutationOptions<CreateFeedPostMutation, CreateFeedPostMutationVariables>;
export const LiveStreamDocument = gql`
    query LiveStream($liveStreamId: Int!) {
  liveStream(liveStreamId: $liveStreamId) {
    id
    imageUrl
    zoomId
    zoomPassword
    startDate
    endDate
    title
    description
    archived
    createdAt
    jwtToken
  }
}
    `;

/**
 * __useLiveStreamQuery__
 *
 * To run a query within a React component, call `useLiveStreamQuery` and pass it any options that fit your needs.
 * When your component renders, `useLiveStreamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveStreamQuery({
 *   variables: {
 *      liveStreamId: // value for 'liveStreamId'
 *   },
 * });
 */
export function useLiveStreamQuery(baseOptions: Apollo.QueryHookOptions<LiveStreamQuery, LiveStreamQueryVariables> & ({ variables: LiveStreamQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LiveStreamQuery, LiveStreamQueryVariables>(LiveStreamDocument, options);
      }
export function useLiveStreamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LiveStreamQuery, LiveStreamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LiveStreamQuery, LiveStreamQueryVariables>(LiveStreamDocument, options);
        }
// @ts-ignore
export function useLiveStreamSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LiveStreamQuery, LiveStreamQueryVariables>): Apollo.UseSuspenseQueryResult<LiveStreamQuery, LiveStreamQueryVariables>;
export function useLiveStreamSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LiveStreamQuery, LiveStreamQueryVariables>): Apollo.UseSuspenseQueryResult<LiveStreamQuery | undefined, LiveStreamQueryVariables>;
export function useLiveStreamSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LiveStreamQuery, LiveStreamQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LiveStreamQuery, LiveStreamQueryVariables>(LiveStreamDocument, options);
        }
export type LiveStreamQueryHookResult = ReturnType<typeof useLiveStreamQuery>;
export type LiveStreamLazyQueryHookResult = ReturnType<typeof useLiveStreamLazyQuery>;
export type LiveStreamSuspenseQueryHookResult = ReturnType<typeof useLiveStreamSuspenseQuery>;
export type LiveStreamQueryResult = Apollo.QueryResult<LiveStreamQuery, LiveStreamQueryVariables>;
export const AdminLiveStreamsDocument = gql`
    query AdminLiveStreams($pagination: Pagination) {
  adminLiveStreams(pagination: $pagination) {
    id
    imageUrl
    zoomId
    startDate
    endDate
    title
    description
    archived
    createdAt
  }
}
    `;

/**
 * __useAdminLiveStreamsQuery__
 *
 * To run a query within a React component, call `useAdminLiveStreamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminLiveStreamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminLiveStreamsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useAdminLiveStreamsQuery(baseOptions?: Apollo.QueryHookOptions<AdminLiveStreamsQuery, AdminLiveStreamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminLiveStreamsQuery, AdminLiveStreamsQueryVariables>(AdminLiveStreamsDocument, options);
      }
export function useAdminLiveStreamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminLiveStreamsQuery, AdminLiveStreamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminLiveStreamsQuery, AdminLiveStreamsQueryVariables>(AdminLiveStreamsDocument, options);
        }
// @ts-ignore
export function useAdminLiveStreamsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminLiveStreamsQuery, AdminLiveStreamsQueryVariables>): Apollo.UseSuspenseQueryResult<AdminLiveStreamsQuery, AdminLiveStreamsQueryVariables>;
export function useAdminLiveStreamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminLiveStreamsQuery, AdminLiveStreamsQueryVariables>): Apollo.UseSuspenseQueryResult<AdminLiveStreamsQuery | undefined, AdminLiveStreamsQueryVariables>;
export function useAdminLiveStreamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminLiveStreamsQuery, AdminLiveStreamsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminLiveStreamsQuery, AdminLiveStreamsQueryVariables>(AdminLiveStreamsDocument, options);
        }
export type AdminLiveStreamsQueryHookResult = ReturnType<typeof useAdminLiveStreamsQuery>;
export type AdminLiveStreamsLazyQueryHookResult = ReturnType<typeof useAdminLiveStreamsLazyQuery>;
export type AdminLiveStreamsSuspenseQueryHookResult = ReturnType<typeof useAdminLiveStreamsSuspenseQuery>;
export type AdminLiveStreamsQueryResult = Apollo.QueryResult<AdminLiveStreamsQuery, AdminLiveStreamsQueryVariables>;
export const CreateLiveStreamDocument = gql`
    mutation CreateLiveStream($liveStreamInput: LiveStreamInput!) {
  createLiveStream(liveStreamInput: $liveStreamInput) {
    id
  }
}
    `;
export type CreateLiveStreamMutationFn = Apollo.MutationFunction<CreateLiveStreamMutation, CreateLiveStreamMutationVariables>;

/**
 * __useCreateLiveStreamMutation__
 *
 * To run a mutation, you first call `useCreateLiveStreamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLiveStreamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLiveStreamMutation, { data, loading, error }] = useCreateLiveStreamMutation({
 *   variables: {
 *      liveStreamInput: // value for 'liveStreamInput'
 *   },
 * });
 */
export function useCreateLiveStreamMutation(baseOptions?: Apollo.MutationHookOptions<CreateLiveStreamMutation, CreateLiveStreamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLiveStreamMutation, CreateLiveStreamMutationVariables>(CreateLiveStreamDocument, options);
      }
export type CreateLiveStreamMutationHookResult = ReturnType<typeof useCreateLiveStreamMutation>;
export type CreateLiveStreamMutationResult = Apollo.MutationResult<CreateLiveStreamMutation>;
export type CreateLiveStreamMutationOptions = Apollo.BaseMutationOptions<CreateLiveStreamMutation, CreateLiveStreamMutationVariables>;
export const ProTeamsDocument = gql`
    query ProTeams {
  proTeams {
    id
    imageUrl
    name
    archived
  }
}
    `;

/**
 * __useProTeamsQuery__
 *
 * To run a query within a React component, call `useProTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProTeamsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProTeamsQuery(baseOptions?: Apollo.QueryHookOptions<ProTeamsQuery, ProTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProTeamsQuery, ProTeamsQueryVariables>(ProTeamsDocument, options);
      }
export function useProTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProTeamsQuery, ProTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProTeamsQuery, ProTeamsQueryVariables>(ProTeamsDocument, options);
        }
// @ts-ignore
export function useProTeamsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProTeamsQuery, ProTeamsQueryVariables>): Apollo.UseSuspenseQueryResult<ProTeamsQuery, ProTeamsQueryVariables>;
export function useProTeamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProTeamsQuery, ProTeamsQueryVariables>): Apollo.UseSuspenseQueryResult<ProTeamsQuery | undefined, ProTeamsQueryVariables>;
export function useProTeamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProTeamsQuery, ProTeamsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProTeamsQuery, ProTeamsQueryVariables>(ProTeamsDocument, options);
        }
export type ProTeamsQueryHookResult = ReturnType<typeof useProTeamsQuery>;
export type ProTeamsLazyQueryHookResult = ReturnType<typeof useProTeamsLazyQuery>;
export type ProTeamsSuspenseQueryHookResult = ReturnType<typeof useProTeamsSuspenseQuery>;
export type ProTeamsQueryResult = Apollo.QueryResult<ProTeamsQuery, ProTeamsQueryVariables>;
export const AddProTeamDocument = gql`
    mutation AddProTeam($input: ProTeamInput!) {
  addProTeam(input: $input) {
    id
  }
}
    `;
export type AddProTeamMutationFn = Apollo.MutationFunction<AddProTeamMutation, AddProTeamMutationVariables>;

/**
 * __useAddProTeamMutation__
 *
 * To run a mutation, you first call `useAddProTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProTeamMutation, { data, loading, error }] = useAddProTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddProTeamMutation(baseOptions?: Apollo.MutationHookOptions<AddProTeamMutation, AddProTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProTeamMutation, AddProTeamMutationVariables>(AddProTeamDocument, options);
      }
export type AddProTeamMutationHookResult = ReturnType<typeof useAddProTeamMutation>;
export type AddProTeamMutationResult = Apollo.MutationResult<AddProTeamMutation>;
export type AddProTeamMutationOptions = Apollo.BaseMutationOptions<AddProTeamMutation, AddProTeamMutationVariables>;
export const AdminTeamsDocument = gql`
    query AdminTeams($pagination: Pagination) {
  adminTeams(pagination: $pagination) {
    id
    name
    code
    location
    createdAt
    playerCount
    archived
    coach {
      id
      fullName
    }
  }
}
    `;

/**
 * __useAdminTeamsQuery__
 *
 * To run a query within a React component, call `useAdminTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminTeamsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useAdminTeamsQuery(baseOptions?: Apollo.QueryHookOptions<AdminTeamsQuery, AdminTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminTeamsQuery, AdminTeamsQueryVariables>(AdminTeamsDocument, options);
      }
export function useAdminTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminTeamsQuery, AdminTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminTeamsQuery, AdminTeamsQueryVariables>(AdminTeamsDocument, options);
        }
// @ts-ignore
export function useAdminTeamsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminTeamsQuery, AdminTeamsQueryVariables>): Apollo.UseSuspenseQueryResult<AdminTeamsQuery, AdminTeamsQueryVariables>;
export function useAdminTeamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminTeamsQuery, AdminTeamsQueryVariables>): Apollo.UseSuspenseQueryResult<AdminTeamsQuery | undefined, AdminTeamsQueryVariables>;
export function useAdminTeamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminTeamsQuery, AdminTeamsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminTeamsQuery, AdminTeamsQueryVariables>(AdminTeamsDocument, options);
        }
export type AdminTeamsQueryHookResult = ReturnType<typeof useAdminTeamsQuery>;
export type AdminTeamsLazyQueryHookResult = ReturnType<typeof useAdminTeamsLazyQuery>;
export type AdminTeamsSuspenseQueryHookResult = ReturnType<typeof useAdminTeamsSuspenseQuery>;
export type AdminTeamsQueryResult = Apollo.QueryResult<AdminTeamsQuery, AdminTeamsQueryVariables>;
export const TeamNameByCodeDocument = gql`
    query TeamNameByCode($code: String!) {
  teamNameByCode(code: $code) {
    name
  }
}
    `;

/**
 * __useTeamNameByCodeQuery__
 *
 * To run a query within a React component, call `useTeamNameByCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamNameByCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamNameByCodeQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useTeamNameByCodeQuery(baseOptions: Apollo.QueryHookOptions<TeamNameByCodeQuery, TeamNameByCodeQueryVariables> & ({ variables: TeamNameByCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamNameByCodeQuery, TeamNameByCodeQueryVariables>(TeamNameByCodeDocument, options);
      }
export function useTeamNameByCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamNameByCodeQuery, TeamNameByCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamNameByCodeQuery, TeamNameByCodeQueryVariables>(TeamNameByCodeDocument, options);
        }
// @ts-ignore
export function useTeamNameByCodeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TeamNameByCodeQuery, TeamNameByCodeQueryVariables>): Apollo.UseSuspenseQueryResult<TeamNameByCodeQuery, TeamNameByCodeQueryVariables>;
export function useTeamNameByCodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TeamNameByCodeQuery, TeamNameByCodeQueryVariables>): Apollo.UseSuspenseQueryResult<TeamNameByCodeQuery | undefined, TeamNameByCodeQueryVariables>;
export function useTeamNameByCodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TeamNameByCodeQuery, TeamNameByCodeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TeamNameByCodeQuery, TeamNameByCodeQueryVariables>(TeamNameByCodeDocument, options);
        }
export type TeamNameByCodeQueryHookResult = ReturnType<typeof useTeamNameByCodeQuery>;
export type TeamNameByCodeLazyQueryHookResult = ReturnType<typeof useTeamNameByCodeLazyQuery>;
export type TeamNameByCodeSuspenseQueryHookResult = ReturnType<typeof useTeamNameByCodeSuspenseQuery>;
export type TeamNameByCodeQueryResult = Apollo.QueryResult<TeamNameByCodeQuery, TeamNameByCodeQueryVariables>;
export const AddEventConfirmationDocument = gql`
    mutation AddEventConfirmation($input: EventConfirmationInput!) {
  addEventConfirmation(input: $input) {
    id
    userId
    eventId
    createdAt
    updatedAt
    going
    status
  }
}
    `;
export type AddEventConfirmationMutationFn = Apollo.MutationFunction<AddEventConfirmationMutation, AddEventConfirmationMutationVariables>;

/**
 * __useAddEventConfirmationMutation__
 *
 * To run a mutation, you first call `useAddEventConfirmationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEventConfirmationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEventConfirmationMutation, { data, loading, error }] = useAddEventConfirmationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddEventConfirmationMutation(baseOptions?: Apollo.MutationHookOptions<AddEventConfirmationMutation, AddEventConfirmationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEventConfirmationMutation, AddEventConfirmationMutationVariables>(AddEventConfirmationDocument, options);
      }
export type AddEventConfirmationMutationHookResult = ReturnType<typeof useAddEventConfirmationMutation>;
export type AddEventConfirmationMutationResult = Apollo.MutationResult<AddEventConfirmationMutation>;
export type AddEventConfirmationMutationOptions = Apollo.BaseMutationOptions<AddEventConfirmationMutation, AddEventConfirmationMutationVariables>;
export const MeDocument = gql`
    query Me {
  me {
    token
    user {
      ...CurrentUserFields
    }
  }
}
    ${CurrentUserFieldsFragmentDoc}`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
// @ts-ignore
export function useMeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>): Apollo.UseSuspenseQueryResult<MeQuery, MeQueryVariables>;
export function useMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>): Apollo.UseSuspenseQueryResult<MeQuery | undefined, MeQueryVariables>;
export function useMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeSuspenseQueryHookResult = ReturnType<typeof useMeSuspenseQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const LoginDocument = gql`
    mutation Login($phone: String!, $password: String!) {
  login(phoneNumber: $phone, password: $password) {
    token
    user {
      ...CurrentUserFields
    }
  }
}
    ${CurrentUserFieldsFragmentDoc}`;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      phone: // value for 'phone'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const RegisterDocument = gql`
    mutation Register($userInput: UserInput!) {
  register(userInput: $userInput) {
    token
    user {
      ...CurrentUserFields
    }
  }
}
    ${CurrentUserFieldsFragmentDoc}`;
export type RegisterMutationFn = Apollo.MutationFunction<RegisterMutation, RegisterMutationVariables>;

/**
 * __useRegisterMutation__
 *
 * To run a mutation, you first call `useRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMutation, { data, loading, error }] = useRegisterMutation({
 *   variables: {
 *      userInput: // value for 'userInput'
 *   },
 * });
 */
export function useRegisterMutation(baseOptions?: Apollo.MutationHookOptions<RegisterMutation, RegisterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterMutation, RegisterMutationVariables>(RegisterDocument, options);
      }
export type RegisterMutationHookResult = ReturnType<typeof useRegisterMutation>;
export type RegisterMutationResult = Apollo.MutationResult<RegisterMutation>;
export type RegisterMutationOptions = Apollo.BaseMutationOptions<RegisterMutation, RegisterMutationVariables>;
export const AdminModifyUserDocument = gql`
    mutation AdminModifyUser($userId: String, $modifyUserInput: AdminModifyUserInput!) {
  adminModifyUser(modifyUserInput: $modifyUserInput, userId: $userId) {
    ...GenericUserFields
  }
}
    ${GenericUserFieldsFragmentDoc}`;
export type AdminModifyUserMutationFn = Apollo.MutationFunction<AdminModifyUserMutation, AdminModifyUserMutationVariables>;

/**
 * __useAdminModifyUserMutation__
 *
 * To run a mutation, you first call `useAdminModifyUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminModifyUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminModifyUserMutation, { data, loading, error }] = useAdminModifyUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      modifyUserInput: // value for 'modifyUserInput'
 *   },
 * });
 */
export function useAdminModifyUserMutation(baseOptions?: Apollo.MutationHookOptions<AdminModifyUserMutation, AdminModifyUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminModifyUserMutation, AdminModifyUserMutationVariables>(AdminModifyUserDocument, options);
      }
export type AdminModifyUserMutationHookResult = ReturnType<typeof useAdminModifyUserMutation>;
export type AdminModifyUserMutationResult = Apollo.MutationResult<AdminModifyUserMutation>;
export type AdminModifyUserMutationOptions = Apollo.BaseMutationOptions<AdminModifyUserMutation, AdminModifyUserMutationVariables>;
export const DeleteFeedPostDocument = gql`
    mutation DeleteFeedPost($id: ID!) {
  deleteFeedPost(id: $id) {
    success
    message
  }
}
    `;
export type DeleteFeedPostMutationFn = Apollo.MutationFunction<DeleteFeedPostMutation, DeleteFeedPostMutationVariables>;

/**
 * __useDeleteFeedPostMutation__
 *
 * To run a mutation, you first call `useDeleteFeedPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFeedPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFeedPostMutation, { data, loading, error }] = useDeleteFeedPostMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFeedPostMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFeedPostMutation, DeleteFeedPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFeedPostMutation, DeleteFeedPostMutationVariables>(DeleteFeedPostDocument, options);
      }
export type DeleteFeedPostMutationHookResult = ReturnType<typeof useDeleteFeedPostMutation>;
export type DeleteFeedPostMutationResult = Apollo.MutationResult<DeleteFeedPostMutation>;
export type DeleteFeedPostMutationOptions = Apollo.BaseMutationOptions<DeleteFeedPostMutation, DeleteFeedPostMutationVariables>;
export const UpdateFeedPostDocument = gql`
    mutation UpdateFeedPost($updateFeedPostId: ID!, $input: UpdateFeedPostInput!) {
  updateFeedPost(id: $updateFeedPostId, input: $input) {
    id
    imageUrl
    category
    contentSource
    description
    createdAt
    archived
    likeCount
    commentCount
    bookmarkCount
    categoryId
  }
}
    `;
export type UpdateFeedPostMutationFn = Apollo.MutationFunction<UpdateFeedPostMutation, UpdateFeedPostMutationVariables>;

/**
 * __useUpdateFeedPostMutation__
 *
 * To run a mutation, you first call `useUpdateFeedPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeedPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeedPostMutation, { data, loading, error }] = useUpdateFeedPostMutation({
 *   variables: {
 *      updateFeedPostId: // value for 'updateFeedPostId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFeedPostMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFeedPostMutation, UpdateFeedPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFeedPostMutation, UpdateFeedPostMutationVariables>(UpdateFeedPostDocument, options);
      }
export type UpdateFeedPostMutationHookResult = ReturnType<typeof useUpdateFeedPostMutation>;
export type UpdateFeedPostMutationResult = Apollo.MutationResult<UpdateFeedPostMutation>;
export type UpdateFeedPostMutationOptions = Apollo.BaseMutationOptions<UpdateFeedPostMutation, UpdateFeedPostMutationVariables>;
export const SendPushToAllDocument = gql`
    mutation SendPushToAll($text: String, $title: String, $owners: Boolean, $ids: String) {
  sendPushToAll(text: $text, title: $title, owners: $owners, ids: $ids)
}
    `;
export type SendPushToAllMutationFn = Apollo.MutationFunction<SendPushToAllMutation, SendPushToAllMutationVariables>;

/**
 * __useSendPushToAllMutation__
 *
 * To run a mutation, you first call `useSendPushToAllMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPushToAllMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPushToAllMutation, { data, loading, error }] = useSendPushToAllMutation({
 *   variables: {
 *      text: // value for 'text'
 *      title: // value for 'title'
 *      owners: // value for 'owners'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useSendPushToAllMutation(baseOptions?: Apollo.MutationHookOptions<SendPushToAllMutation, SendPushToAllMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendPushToAllMutation, SendPushToAllMutationVariables>(SendPushToAllDocument, options);
      }
export type SendPushToAllMutationHookResult = ReturnType<typeof useSendPushToAllMutation>;
export type SendPushToAllMutationResult = Apollo.MutationResult<SendPushToAllMutation>;
export type SendPushToAllMutationOptions = Apollo.BaseMutationOptions<SendPushToAllMutation, SendPushToAllMutationVariables>;
export const SendPushAboutFeedDocument = gql`
    mutation SendPushAboutFeed($text: String, $id: Int) {
  sendPushAboutFeed(text: $text, id: $id)
}
    `;
export type SendPushAboutFeedMutationFn = Apollo.MutationFunction<SendPushAboutFeedMutation, SendPushAboutFeedMutationVariables>;

/**
 * __useSendPushAboutFeedMutation__
 *
 * To run a mutation, you first call `useSendPushAboutFeedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPushAboutFeedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPushAboutFeedMutation, { data, loading, error }] = useSendPushAboutFeedMutation({
 *   variables: {
 *      text: // value for 'text'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSendPushAboutFeedMutation(baseOptions?: Apollo.MutationHookOptions<SendPushAboutFeedMutation, SendPushAboutFeedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendPushAboutFeedMutation, SendPushAboutFeedMutationVariables>(SendPushAboutFeedDocument, options);
      }
export type SendPushAboutFeedMutationHookResult = ReturnType<typeof useSendPushAboutFeedMutation>;
export type SendPushAboutFeedMutationResult = Apollo.MutationResult<SendPushAboutFeedMutation>;
export type SendPushAboutFeedMutationOptions = Apollo.BaseMutationOptions<SendPushAboutFeedMutation, SendPushAboutFeedMutationVariables>;
export const SendTestEmailDocument = gql`
    mutation SendTestEmail($email: String!, $subject: String, $html: String) {
  sendTestEmail(email: $email, subject: $subject, html: $html)
}
    `;
export type SendTestEmailMutationFn = Apollo.MutationFunction<SendTestEmailMutation, SendTestEmailMutationVariables>;

/**
 * __useSendTestEmailMutation__
 *
 * To run a mutation, you first call `useSendTestEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTestEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTestEmailMutation, { data, loading, error }] = useSendTestEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *      subject: // value for 'subject'
 *      html: // value for 'html'
 *   },
 * });
 */
export function useSendTestEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendTestEmailMutation, SendTestEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendTestEmailMutation, SendTestEmailMutationVariables>(SendTestEmailDocument, options);
      }
export type SendTestEmailMutationHookResult = ReturnType<typeof useSendTestEmailMutation>;
export type SendTestEmailMutationResult = Apollo.MutationResult<SendTestEmailMutation>;
export type SendTestEmailMutationOptions = Apollo.BaseMutationOptions<SendTestEmailMutation, SendTestEmailMutationVariables>;
export const FeedPostDocument = gql`
    query FeedPost($feedPostId: Int!) {
  feedPost(feedPostId: $feedPostId) {
    id
    imageUrl
    thumbnailUrl
    description
    category
    categoryId
  }
}
    `;

/**
 * __useFeedPostQuery__
 *
 * To run a query within a React component, call `useFeedPostQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedPostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedPostQuery({
 *   variables: {
 *      feedPostId: // value for 'feedPostId'
 *   },
 * });
 */
export function useFeedPostQuery(baseOptions: Apollo.QueryHookOptions<FeedPostQuery, FeedPostQueryVariables> & ({ variables: FeedPostQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeedPostQuery, FeedPostQueryVariables>(FeedPostDocument, options);
      }
export function useFeedPostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeedPostQuery, FeedPostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeedPostQuery, FeedPostQueryVariables>(FeedPostDocument, options);
        }
// @ts-ignore
export function useFeedPostSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FeedPostQuery, FeedPostQueryVariables>): Apollo.UseSuspenseQueryResult<FeedPostQuery, FeedPostQueryVariables>;
export function useFeedPostSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeedPostQuery, FeedPostQueryVariables>): Apollo.UseSuspenseQueryResult<FeedPostQuery | undefined, FeedPostQueryVariables>;
export function useFeedPostSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeedPostQuery, FeedPostQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FeedPostQuery, FeedPostQueryVariables>(FeedPostDocument, options);
        }
export type FeedPostQueryHookResult = ReturnType<typeof useFeedPostQuery>;
export type FeedPostLazyQueryHookResult = ReturnType<typeof useFeedPostLazyQuery>;
export type FeedPostSuspenseQueryHookResult = ReturnType<typeof useFeedPostSuspenseQuery>;
export type FeedPostQueryResult = Apollo.QueryResult<FeedPostQuery, FeedPostQueryVariables>;
export const CategoriesDocument = gql`
    query Categories($filters: [FilterConditionInput!], $pagination: Pagination) {
  categories(filters: $filters, pagination: $pagination) {
    archived
    createdAt
    description
    forCoach
    forFeed
    id
    name
    title
    updatedAt
  }
}
    `;

/**
 * __useCategoriesQuery__
 *
 * To run a query within a React component, call `useCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoriesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<CategoriesQuery, CategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoriesQuery, CategoriesQueryVariables>(CategoriesDocument, options);
      }
export function useCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoriesQuery, CategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoriesQuery, CategoriesQueryVariables>(CategoriesDocument, options);
        }
// @ts-ignore
export function useCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CategoriesQuery, CategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<CategoriesQuery, CategoriesQueryVariables>;
export function useCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CategoriesQuery, CategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<CategoriesQuery | undefined, CategoriesQueryVariables>;
export function useCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CategoriesQuery, CategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CategoriesQuery, CategoriesQueryVariables>(CategoriesDocument, options);
        }
export type CategoriesQueryHookResult = ReturnType<typeof useCategoriesQuery>;
export type CategoriesLazyQueryHookResult = ReturnType<typeof useCategoriesLazyQuery>;
export type CategoriesSuspenseQueryHookResult = ReturnType<typeof useCategoriesSuspenseQuery>;
export type CategoriesQueryResult = Apollo.QueryResult<CategoriesQuery, CategoriesQueryVariables>;
export const ImportNotificationsDocument = gql`
    mutation ImportNotifications($fileName: String) {
  importNotifications(fileName: $fileName) {
    message
    success
  }
}
    `;
export type ImportNotificationsMutationFn = Apollo.MutationFunction<ImportNotificationsMutation, ImportNotificationsMutationVariables>;

/**
 * __useImportNotificationsMutation__
 *
 * To run a mutation, you first call `useImportNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importNotificationsMutation, { data, loading, error }] = useImportNotificationsMutation({
 *   variables: {
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useImportNotificationsMutation(baseOptions?: Apollo.MutationHookOptions<ImportNotificationsMutation, ImportNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportNotificationsMutation, ImportNotificationsMutationVariables>(ImportNotificationsDocument, options);
      }
export type ImportNotificationsMutationHookResult = ReturnType<typeof useImportNotificationsMutation>;
export type ImportNotificationsMutationResult = Apollo.MutationResult<ImportNotificationsMutation>;
export type ImportNotificationsMutationOptions = Apollo.BaseMutationOptions<ImportNotificationsMutation, ImportNotificationsMutationVariables>;